import { ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl, Validator } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { Listas } from 'src/app/models/generic/Listas';
import { ConfiguracionInicialService } from 'src/app/services/configuracioninicial.service';
import { MenuService } from 'src/app/services/menu.service';
import { UtilitariosService } from 'src/app/services/utilitarios.service';
import { Producto } from '../../models/generic/Producto';
import { ProductosService } from '../../services/productos.service';
import { ConfiguracionService } from '../../services/configuracion.service';
import { Constantes } from '../../models/modules/Constantes';
import { RespuestaGenerica } from '../../models/generic/RespuestaGenerica';
import { ConfirmacionGenericaComponent } from '../confirmaciongenerica/confirmaciongenerica.component';
import { RegistroAfiliado } from 'src/app/models/generic/RegistroAfiliado';
import { TamanoAppService } from 'src/app/services/tamanoapp.service';
import { ClientesProspecto } from '../../models/generic/ClienteProspecto';
import { AutenticacionService } from '../../services/autenticacion.service';
import { Estados } from 'src/app/models/generic/Estados';
import { ProductosEdades } from 'src/app/models/generic/ProductosEdades';
import { GestionAfiliadoService } from 'src/app/services/gestionafiliado.service';
import { AliadoDatosAdicionales } from 'src/app/models/generic/AliadoDatosAdicionales';
import { Parentescos } from '../../models/generic/Parentescos';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { GestionAfiliado_Beneficiados } from 'src/app/models/generic/GestionAfiliado_Beneficiados';
import { Maestro_AliadosPorcentajeBeneficiarios } from '../../models/generic/Maestro_AliadosPorcentajeBeneficiarios';
import { Maestros_AliadosPorcentajesBeneficiariosService } from 'src/app/services/maestros_aliadosporcentajesbeneficiarios.service';
import { Maestro_EstadoActualizar } from 'src/app/models/generic/Maestro_EstadoActualizar';
import { MatTabGroup } from '@angular/material/tabs';
import { GestionAfiliadoEdicionRegistro } from 'src/app/models/generic/GestionAfiliadoEdicionRegistro';
import { GestionAfiliado_Parametro } from 'src/app/models/generic/GestionAfiliado_Parametro';
import { MarcasReferencias } from 'src/app/models/generic/MarcasReferencias';
import { GestionAfiliado_Documentos } from 'src/app/models/generic/GestionAfiliado_Documentos';
import { Marcas } from 'src/app/models/generic/Marcas';
import { GestionAfiliado_DocumentosConsulta } from 'src/app/models/generic/GestionAfiliado_DocumentosConsulta';

@Component({
  selector: 'registrar-afiliado',
  templateUrl: './registrar-afiliado.component.html',
  styleUrls: ['./registrar-afiliado.component.scss']
})
export class RegistrarAfiliadoComponent implements OnInit{
  TABS_DATOS = 'tabinicial';
  TABS_BENEFICIARIOS = 'tabbeneficiarios';
  TABS_TOMADOR = 'tabtomador';
  TABS_INFORMACIONVEHICULO = 'tabInformacionVehiculo';
  TABS_REGISTROFOTOGRAFICO = 'tabRegistroFotrografico';
  form: FormGroup;
  formTomador: FormGroup;
  formBeneficiados: FormGroup;
  formInformacionVehiculo: FormGroup;
  listaConfiguracionCampos: Listas[] = [];
  listaTiposIdentificacion: Listas[] = [];
  listaGeneros: Listas[] = [];
  listaTipoPlan: Listas[] = [];
  listaPlanes: Listas[] = [];
  listaTipoRiesgo: Listas[] = [];
  listaDepartamentos: Listas[] = [];
  listaCiudades: Listas[] = [];
  listaCiudadesExpedicion: Listas[] = [];
  listaCiudadesTomador: Listas[] = [];
  listaPlazoProducto: Listas[] = [];
  listaCamposBeneficiarios: Listas[] = [];
  listaCamposBeneficiariosProducto: Listas[] = [];
  listaCamposBeneficiariosProductoMostrar: Listas[] = [];
  listaTiposBeneficiarios: Listas[] = [];
  listaTipoAsegurado: Listas[] = [];
  listaProductosOcultarBeneficiarios: Listas[] = [];
  listaProductosBeneficiariosRequeridos: Listas[] = [];
  listaProductosTomador: Listas[] = [];
  listaPeriodosPago: Listas[] = [];
  listaEdadesNacimiento: Listas[] = [];
  listaProductosAnnosModelo: Listas[] = [];
  listaMarcas: Marcas[] = [];
  listaMarcasFiltrada: Marcas[] = [];
  listaMarcasRefecencias: MarcasReferencias[] = [];
  listaMarcasRefecenciasFiltrada: MarcasReferencias[] = [];
  listaCondicionSiNo: Maestro_EstadoActualizar[] = [];
  mostrarCargando: boolean = false;
  @ViewChild('appconfirmacion', {static: false}) _appconfirmacion: ConfirmacionGenericaComponent;
  @ViewChild('tabGroup', {static: false}) _tabGroup: MatTabGroup;
  @ViewChild('uploadFile', {static: false}) _uploadFile: ElementRef;
  @ViewChild('inputMarca', {static: false}) _inputMarca: ElementRef<HTMLInputElement>;
  @ViewChild('inputMarcaReferencia', {static: false}) _inputMarcaReferencia: ElementRef<HTMLInputElement>;
  listaEstados: Estados[];
  listaProductosEdades: ProductosEdades[];
  listaProductosEdadesFiltrada: ProductosEdades[];
  listaParentescos: Parentescos[];
  registrarEstado: boolean = false;
  mostrarCampoEstado: boolean = true;
  calculoPrecioEdad: boolean = false;
  registrarBenefiarios: boolean = false;
  beneficiariosRequerido: boolean = false;
  registrarFechaNacimiento: boolean = false;
  registrarDomicilio: boolean = false;
  registrarObservaciones: boolean = false;
  edadMinima: number = 18;
  edadMaxima: number = 1000;
  edadMinimaTomador: number = 18;
  edadMaximaTomador: number = 1000;
  editarRegistroBeneficiados: boolean = false;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  dataSourceBeneficiados: MatTableDataSource<GestionAfiliado_Beneficiados>;
  columnasEncabezadoBeneficiados: string[] = ['nroDocumento', 'nombres', 'apellidos', 'parentescoDescripcion', 'participacion', 'acciones'];
  listaDatosBeneficiados: GestionAfiliado_Beneficiados[] = [];
  listaDatosBeneficiadosEliminar: GestionAfiliado_Beneficiados[] = [];
  listaDatosDocumentos: GestionAfiliado_Documentos[] = [];
  listaDatosDocumentosUsuario: GestionAfiliado_Documentos[] = [];
  detalleSeleccionadoBeneficiario: GestionAfiliado_Beneficiados = new GestionAfiliado_Beneficiados();
  codigoAccion: string = '';
  detalleSeleccionado: number = 0;
  idTabSeleccionado: number = 0;
  tabSeleccionadoLabel: string = 'tabinicial';
  notificarCambios: boolean = false;
  listaPorcentajesBeneficiarios: Maestro_AliadosPorcentajeBeneficiarios[] = [];
  iniciarFormularioBeneficiarios: boolean = true;
  tituloBotonRegistrar: string = 'Registrar afiliación';
  deshabilitarProducto: boolean = false;
  ejecutarCambiarDatosTomador: boolean = true;
  ejecutarAsignacionTomador: boolean = true;
  esEdicionRegistro: boolean = false;
  filtroPantallaGestionAfiliado: string = '';
  tituloBotonRegistroFotografico: string = 'Registro fotografico';
  filtroArchivosFotografico: string = '.pdf,image/*';
  mostrarBuscadorMarca: boolean = true;
  mostrarBuscadorMarcaReferencia: boolean = true;
  
  constructor(public router: Router,
    public fb: FormBuilder,
    public cd: ChangeDetectorRef,
    public snackbar: MatSnackBar,
    public utilitariosService: UtilitariosService,
    public configuracionInicialService: ConfiguracionInicialService,
    public menuService: MenuService,
    public productosService: ProductosService,
    public configuracionService: ConfiguracionService,
    public tamanoAppService: TamanoAppService,
    public autenticacionService: AutenticacionService,
    public gestionAfiliadoService: GestionAfiliadoService,
    public datosPorcentajesBeneficiariosServices: Maestros_AliadosPorcentajesBeneficiariosService) {
  }

  ngOnInit() {
    this.IniciarFormularioInformacionVehiculo();

    this.CargarListasIniciales();
    this.CargarListaMarcas();

    this.IniciarFormulario();
    this.IniciarFormularioTomador();
    this.ConsultarListaEstados();
    this.ConsultarListaProductosEdades();
    this.ConsultarRegistrosPorcentajesBeneficiarios();

    this.listaCondicionSiNo = [];
    this.listaCondicionSiNo.push({ seleccionado: true, descripcion: 'Si' });
    this.listaCondicionSiNo.push({ seleccionado: false, descripcion: 'No' });

    this.menuService.NotificarAccionBotonPrincipal.subscribe((accion: string) => {
      if (accion === 'check') {
        this.CrearAfiliado();
      }
    });

    setTimeout(() => {
      this.CargarProductosRegistro();  
    });
  }
  ngAfterViewInit() {
    this.utilitariosService.EstablecerTextoPaginado(this.paginator);
  }

  IniciarFormulario() {
    this.form = this.fb.group({
      idUnico: [0],
      id: [0],
      idProducto: [0, [Validators.required, Validators.min(1)]],
      nroDocumento: ['', [Validators.required, Validators.maxLength(20), Validators.pattern('^[A-Za-z0-9\s]*$')]],
      nombres: ['', [Validators.required, Validators.maxLength(100)]],
      apellidos: ['', [Validators.required, Validators.maxLength(100)]],
      nroMovil: ['', [Validators.required, Validators.maxLength(20)]],
      nroFijo: ['', [Validators.maxLength(20)]],
      email: ['', [Validators.required, Validators.maxLength(40), Validators.email]],
      domicilio: [''],
      idDepartamento: [''],
      idCiudad: [''],
      nacimiento: [new Date()],
      idProductoPlazo: [0, [Validators.required, Validators.min(1)]],
      idAplicacion: 0,
      idAliado: 0,
      aliado: '',
      idCanal: 0,
      canal: '',
      edad: [0],
      idProductoEdad: 0,
      idProductoEdadDescripcion: '',
      idEstado: 0,
      nroPoliza: ['', Validators.maxLength(100)],
      observaciones: ['', Validators.maxLength(500)],
      tipoIdentificacion: '',
      expedicionDocumento: [new Date()],
      departamentoExpedicionDocumento: [''],
      ciudadExpedicionDocumento: [''],
      genero: [0],
      tipoPlan: [0],
      filtroPlan: [0],
      plan: [0],
      precio: [0],
      tipoRiesgo: [0],
      barrio: [''],
      nroPisos: [''],
      tipoAsegurado: [''],
      identificacionPagador: [''],
      periodoPago: [''],
      tomadorIgualAsegurado: [false],
      nroDocumentoTomador: [''],
      nombresTomador: [''],
      apellidosTomador: [''],
      nroMovilTomador: [''],
      nroFijoTomador: [''],
      emailTomador: [''],
      domicilioTomador: [''],
      idDepartamentoTomador: [''],
      idCiudadTomador: [''],
      nacimientoTomador: [new Date()],
      edadTomador: [0],
      marca: [0],
      marcaDescripcion: [''],
      referencia: [0],
      referenciaDescripcion: [''],
      modelo: [0],
      placa: [''],
      listaBeneficiados: [],
      listaBeneficiadosEliminar: [],
      listaDocumentos: [],
      listaDocumentosEliminar: [],
    });

    this.form.get('idAplicacion').setValue(this.autenticacionService.AplicacionSeleccionado);
    this.form.get('idAliado').setValue(this.autenticacionService.AliadoSeleccionado);
    this.form.get('aliado').setValue(this.autenticacionService.DescripcionAliadoSeleccionado);
    this.form.get('idCanal').setValue(this.autenticacionService.CanalSeleccionado);
    this.form.get('canal').setValue(this.autenticacionService.DescripcionCanalSeleccionado);
    this.form.get('idProductoEdadDescripcion').disable();
    this.form.get('precio').disable();

    this.form.get('idDepartamento').valueChanges.subscribe((valorNuevo) => {
      this.CargarListaCiudades(valorNuevo);
    });
    this.form.get('idProducto').valueChanges.subscribe((valorNuevo) => {
      this.CambioProducto(valorNuevo);
    });
    this.form.get('nacimiento').valueChanges.subscribe((valorNuevo) => {
      this.form.get('edad').setValue(this.utilitariosService.CalcularEdad(valorNuevo));
    });
    this.form.get('edad').valueChanges.subscribe((valorNuevo) => {
      this.AsignarProductoEdad(valorNuevo);
      this.CargarPrecioPlan(this.form.get('filtroPlan').value, valorNuevo);
    });
    this.form.get('departamentoExpedicionDocumento').valueChanges.subscribe((valorNuevo) => {
      this.CargarListaCiudadesExpedicion(valorNuevo);
    });

    if (this.utilitariosService.VerificarContieneDatosTexto(this.menuService.ParametrosAdicionales)) {
      let itemProducto: Producto = JSON.parse(this.menuService.ParametrosAdicionales);
      this.form.get('idProducto').setValue(itemProducto.id);
      this.CambioProducto(itemProducto.id);
    } else {
      this.CargarListaBeneficiarios(0);
    }
  }
  IniciarFormularioTomador() {
    this.formTomador = this.fb.group({
      tomadorIgualAsegurado: [false],
      nroDocumentoTomador: [''],
      nombresTomador: [''],
      apellidosTomador: [''],
      nroMovilTomador: [''],
      nroFijoTomador: [''],
      emailTomador: [''],
      domicilioTomador: [''],
      idDepartamentoTomador: [''],
      idCiudadTomador: [''],
      nacimientoTomador: [new Date()],
      edadTomador: [0],

      nroDocumentoTomadorDeshabilitado: [''],
      nombresTomadorDeshabilitado: [''],
      apellidosTomadorDeshabilitado: [''],
      nroMovilTomadorDeshabilitado: [''],
      nroFijoTomadorDeshabilitado: [''],
      emailTomadorDeshabilitado: [''],
      domicilioTomadorDeshabilitado: [''],
      departamentoTomadorDeshabilitado: [''],
      ciudadTomadorDeshabilitado: [''],
      nacimientoTomadorDeshabilitado: [new Date()],
    });

    this.formTomador.get('nroDocumentoTomadorDeshabilitado').disable();
    this.formTomador.get('nombresTomadorDeshabilitado').disable();
    this.formTomador.get('apellidosTomadorDeshabilitado').disable();
    this.formTomador.get('nroMovilTomadorDeshabilitado').disable();
    this.formTomador.get('nroFijoTomadorDeshabilitado').disable();
    this.formTomador.get('emailTomadorDeshabilitado').disable();
    this.formTomador.get('domicilioTomadorDeshabilitado').disable();
    this.formTomador.get('departamentoTomadorDeshabilitado').disable();
    this.formTomador.get('ciudadTomadorDeshabilitado').disable();
    this.formTomador.get('nacimientoTomadorDeshabilitado').disable();

    this.formTomador.get('idDepartamentoTomador').valueChanges.subscribe((valorNuevo) => {
      
      if (this.utilitariosService.VerificarContieneDatosLista(this.listaDepartamentos)) {
        if (this.listaDepartamentos.filter(x => x.codigo === valorNuevo).length > 0) {
          this.formTomador.get('departamentoTomadorDeshabilitado').setValue(this.listaDepartamentos.filter(x => x.codigo === valorNuevo)[0].descripcion);
        }
      }
      
      this.CargarListaCiudadesTomador(valorNuevo);
    });
    this.formTomador.get('idCiudadTomador').valueChanges.subscribe((valorNuevo) => {

      if (this.utilitariosService.VerificarContieneDatosLista(this.listaCiudadesTomador)) {
        if (this.listaCiudadesTomador.filter(x => x.codigo === valorNuevo).length > 0) {
          this.formTomador.get('ciudadTomadorDeshabilitado').setValue(this.listaCiudadesTomador.filter(x => x.codigo === valorNuevo)[0].descripcion);
        }
      }
    });

    this.formTomador.get('tomadorIgualAsegurado').valueChanges.subscribe((valorNuevo) => {
      if (this.ejecutarCambiarDatosTomador) {
        this.ejecutarAsignacionTomador = true; 
      }
      this.EstablecerDatosTomadorRequeridos(valorNuevo);
    });

    this.formTomador.get('nacimientoTomador').valueChanges.subscribe((valorNuevo) => {
      this.formTomador.get('edadTomador').setValue(this.utilitariosService.CalcularEdad(valorNuevo));
    });

    this.EstablecerDatosTomadorRequeridos();
  }
  IniciarFormularioBeneficiado() {
    this.formBeneficiados = this.fb.group({
      id: [0],
      nroDocumento: [''],
      nombres: [''],
      apellidos: [''],
      parentesco: [0],
      parentescoDescripcion: [''],
      participacion: [0],
      tipoBeneficiario: [0],
      tipoBeneficiarioDescripcion: [''],
      tipoIdentificacion: [''],
      tipoIdentificacionDescripcion: [''],
      raza: [''],
      nacimiento: [new Date()],
      edad: [0],
      color: [''],
      genero: [0],
      generoDescripcion: [''],
    });

    this.formBeneficiados.get('parentesco').valueChanges.subscribe((valorNuevo) => {
      if (this.listaParentescos.filter(x => x.id === valorNuevo).length > 0) {
        this.formBeneficiados.get('parentescoDescripcion').setValue(this.listaParentescos.filter(x => x.id === valorNuevo)[0].descripcion);
      }
    });
    this.formBeneficiados.get('tipoBeneficiario').valueChanges.subscribe((valorNuevo) => {
      if (this.listaTiposBeneficiarios.filter(x => x.id === valorNuevo).length > 0) {
        this.formBeneficiados.get('tipoBeneficiarioDescripcion').setValue(this.listaTiposBeneficiarios.filter(x => x.id === valorNuevo)[0].descripcion);
      }
    });
    this.formBeneficiados.get('tipoIdentificacion').valueChanges.subscribe((valorNuevo) => {
      if (this.listaTiposIdentificacion.filter(x => x.codigo === valorNuevo).length > 0) {
        this.formBeneficiados.get('tipoIdentificacionDescripcion').setValue(this.listaTiposIdentificacion.filter(x => x.codigo === valorNuevo)[0].descripcion);
      }
    });
    this.formBeneficiados.get('genero').valueChanges.subscribe((valorNuevo) => {
      if (this.listaGeneros.filter(x => x.id === valorNuevo).length > 0) {
        this.formBeneficiados.get('generoDescripcion').setValue(this.listaGeneros.filter(x => x.id === valorNuevo)[0].descripcion);
      }
    });
    this.formBeneficiados.get('nacimiento').valueChanges.subscribe((valorNuevo) => {
      this.formBeneficiados.get('edad').setValue(this.utilitariosService.CalcularEdad(valorNuevo));
    });

    this.EstablecerDatosAdicionalesRequeridosBeneficiario();
  }
  IniciarFormularioInformacionVehiculo() {
    this.formInformacionVehiculo = this.fb.group({
      marca: [0],
      marcaDescripcion: ['', [Validators.required]],
      referencia: [0],
      referenciaDescripcion: ['', [Validators.required]],
      modelo: [0, [Validators.min(1), Validators.max(9999)]],
      placa: ['', [Validators.required, Validators.maxLength(20)]],
    });

    this.formInformacionVehiculo.get('marcaDescripcion').valueChanges.subscribe((valorNuevo) => {
      if (this.mostrarBuscadorMarca) {
        if (this.listaMarcas.filter(x => x.descripcion === valorNuevo).length > 0) {
          let idMarca: number = this.listaMarcas.filter(x => x.descripcion === valorNuevo)[0].id;
          this.formInformacionVehiculo.get('marca')?.setValue(idMarca);
          this.CargarListaReferencias(idMarca);
        } else {
          this.formInformacionVehiculo.get('marca')?.setValue(0);
          this.listaMarcasRefecencias = [];
          this.listaMarcasRefecenciasFiltrada = [];
        }
      }
    });

    this.formInformacionVehiculo.get('referenciaDescripcion').valueChanges.subscribe((valorNuevo) => {
      if (this.mostrarBuscadorMarcaReferencia) {
        if (this.listaMarcasRefecencias.filter(x => x.descripcion === valorNuevo).length > 0) {
          let idMarcaReferencia: number = this.listaMarcasRefecencias.filter(x => x.descripcion === valorNuevo)[0].id;
          this.formInformacionVehiculo.get('marcaReferencia')?.setValue(idMarcaReferencia);
        } else {
          this.formInformacionVehiculo.get('marcaReferencia')?.setValue(0);
        }
      }
    });
  }
  CambioProducto(idProducto: number) {
    console.log('CambioProducto', idProducto);
    this.ConsultarDatosAdicionalesAliado(idProducto);
    this.CargarListaPlazosProducto(idProducto);
    this.CargarListaProductosEdad(idProducto);
    this.CargarListaTipoPlan(idProducto);
    this.CargarListaBeneficiarios(idProducto);
    this.CargarListaTipoBeneficiario(idProducto);
    this.CargarListaTipoAsegurado(idProducto);
    this.ConsultarListaParentescos(idProducto);

    setTimeout(() => {
      this.IniciarFormularioTomador();
      setTimeout(() => {
        this.EstablecerDatosEdicionRegistroTomador();
      });
    });

    setTimeout(() => {
      this.EstablecerDatosAdicionalesRequeridosInformacionVehiculo();
    });
  }
  tabSeleccionado(item: any) {
    console.log('tabSeleccionado', item);
    this.idTabSeleccionado = item.index;
    this.tabSeleccionadoLabel = item.tab.textLabel;
    console.log('label tab', this.tabSeleccionadoLabel);

    if (this.EstaTabSeleccionado(this.TABS_BENEFICIARIOS)) {
      if (this.iniciarFormularioBeneficiarios) {
        this.IniciarFormularioBeneficiado();
        this.iniciarFormularioBeneficiarios = false;
      } else {
        this.EstablecerDatosAdicionalesRequeridosBeneficiario();
      }
    }
    if (this.EstaTabSeleccionado(this.TABS_TOMADOR)) {
      this.CambioTomadorIgualAsegurado();
    }
  }
  EstablecerDatosAdicionalesRequeridos() {
    this.form.get('idEstado').setValidators([]);
    this.form.get('idEstado').updateValueAndValidity();

    this.form.get('edad').setValidators([]);
    this.form.get('edad').updateValueAndValidity();

    this.form.get('idDepartamento').setValidators([]);
    this.form.get('idDepartamento').updateValueAndValidity();

    this.form.get('idCiudad').setValidators([]);
    this.form.get('idCiudad').updateValueAndValidity();

    this.form.get('tipoIdentificacion').setValidators([]);
    this.form.get('tipoIdentificacion').updateValueAndValidity();

    this.form.get('expedicionDocumento').setValidators([]);
    this.form.get('expedicionDocumento').updateValueAndValidity();

    this.form.get('departamentoExpedicionDocumento').setValidators([]);
    this.form.get('departamentoExpedicionDocumento').updateValueAndValidity();

    this.form.get('ciudadExpedicionDocumento').setValidators([]);
    this.form.get('ciudadExpedicionDocumento').updateValueAndValidity();

    this.form.get('genero').setValidators([]);
    this.form.get('genero').updateValueAndValidity();

    this.form.get('tipoPlan').setValidators([]);
    this.form.get('tipoPlan').updateValueAndValidity();

    this.form.get('filtroPlan').setValidators([]);
    this.form.get('filtroPlan').updateValueAndValidity();

    this.form.get('tipoRiesgo').setValidators([]);
    this.form.get('tipoRiesgo').updateValueAndValidity();

    this.form.get('domicilio').setValidators([]);
    this.form.get('domicilio').updateValueAndValidity();

    this.form.get('barrio').setValidators([]);
    this.form.get('barrio').updateValueAndValidity();

    this.form.get('nroPisos').setValidators([]);
    this.form.get('nroPisos').updateValueAndValidity();

    this.form.get('tipoAsegurado').setValidators([]);
    this.form.get('tipoAsegurado').updateValueAndValidity();

    this.form.get('identificacionPagador').setValidators([]);
    this.form.get('identificacionPagador').updateValueAndValidity();

    this.form.get('periodoPago').setValidators([]);
    this.form.get('periodoPago').updateValueAndValidity();

    if (this.registrarEstado) {
      let validatorsEstado = [];
      validatorsEstado.push(Validators.required);
      validatorsEstado.push(Validators.min(1));
      this.form.get('idEstado').setValidators(validatorsEstado);
      this.form.get('idEstado').updateValueAndValidity();
    }

    if (this.registrarFechaNacimiento) {
      if (this.utilitariosService.VerificarContieneDatos(this.listaEdadesNacimiento)) {
        let edadMinima: number = 0;
        let edadMaxima: number = 1000;

        let listaEdadFiltro = this.listaEdadesNacimiento.filter(x => x.id === this.form.get('idProducto').value);
        if (listaEdadFiltro) {
          if (listaEdadFiltro.length > 0) {
            if (listaEdadFiltro[0].condicionEntero1 > 0) {
              edadMinima = listaEdadFiltro[0].condicionEntero1;
            }
            if (listaEdadFiltro[0].condicionEntero2 > 0) {
              edadMaxima = listaEdadFiltro[0].condicionEntero2;
            }   
          }
        }

        this.edadMinima = edadMinima;
        this.edadMaxima = edadMaxima;
      }

      let validatorsEdad = [];
      validatorsEdad.push(Validators.required);
      validatorsEdad.push(Validators.min(this.edadMinima));
      validatorsEdad.push(Validators.max(this.edadMaxima));
      this.form.get('edad').setValidators(validatorsEdad);
      this.form.get('edad').updateValueAndValidity();
    }

    if (this.registrarDomicilio || (this.MostrarCampoProducto('CIUDAD') && this.HabilitarCampoProducto('CIUDAD'))) {
      let validatorsDomicilio = [];
      validatorsDomicilio.push(Validators.required);
      this.form.get('idDepartamento').setValidators(validatorsDomicilio);
      this.form.get('idDepartamento').updateValueAndValidity();

      this.form.get('idCiudad').setValidators(validatorsDomicilio);
      this.form.get('idCiudad').updateValueAndValidity();
    }

    if (this.registrarDomicilio || (this.MostrarCampoProducto('DIRECCION') && this.HabilitarCampoProducto('DIRECCION'))) {
      let validatorsDomicilio = [];
      validatorsDomicilio.push(Validators.required);
      validatorsDomicilio.push(Validators.maxLength(60));
      this.form.get('domicilio').setValidators(validatorsDomicilio);
      this.form.get('domicilio').updateValueAndValidity();
    }

    if (this.MostrarCampoProducto('BARRIO') && this.HabilitarCampoProducto('BARRIO')) {
      let validatorsBarrio = [];
      validatorsBarrio.push(Validators.required);
      validatorsBarrio.push(Validators.maxLength(100));
      this.form.get('barrio').setValidators(validatorsBarrio);
      this.form.get('barrio').updateValueAndValidity();
    }

    if (this.MostrarCampoProducto('NROPISOS') && this.HabilitarCampoProducto('NROPISOS')) {
      let validatorsBarrio = [];
      validatorsBarrio.push(Validators.required);
      validatorsBarrio.push(Validators.maxLength(100));
      this.form.get('nroPisos').setValidators(validatorsBarrio);
      this.form.get('nroPisos').updateValueAndValidity();
    }

    if (this.MostrarCampoProducto('TIPOASEGURADO') && this.HabilitarCampoProducto('TIPOASEGURADO')) {
      let validatorsTipoAsegurado = [];
      validatorsTipoAsegurado.push(Validators.required);
      this.form.get('tipoAsegurado').setValidators(validatorsTipoAsegurado);
      this.form.get('tipoAsegurado').updateValueAndValidity();
    }

    if (this.MostrarCampoProducto('NROIDENTIFICACIONPAGADOR') && this.HabilitarCampoProducto('NROIDENTIFICACIONPAGADOR')) {
      let validatorsNroIdentificacionPagador = [];
      validatorsNroIdentificacionPagador.push(Validators.required);
      validatorsNroIdentificacionPagador.push(Validators.maxLength(20));
      this.form.get('identificacionPagador').setValidators(validatorsNroIdentificacionPagador);
      this.form.get('identificacionPagador').updateValueAndValidity();
    }

    if (this.MostrarCampoProducto('TIPOIDENTIFICACION') && this.HabilitarCampoProducto('TIPOIDENTIFICACION')) {
      let validatorsTipoIdentificacion = [];
      validatorsTipoIdentificacion.push(Validators.required);
      this.form.get('tipoIdentificacion').setValidators(validatorsTipoIdentificacion);
      this.form.get('tipoIdentificacion').updateValueAndValidity();
    }

    if (this.MostrarCampoProducto('FECHAEXPEDICIONDOCUMENTO') && this.HabilitarCampoProducto('FECHAEXPEDICIONDOCUMENTO')) {
      let validatorsExpedicionDocumento = [];
      validatorsExpedicionDocumento.push(Validators.required);
      this.form.get('expedicionDocumento').setValidators(validatorsExpedicionDocumento);
      this.form.get('expedicionDocumento').updateValueAndValidity();
    }

    if (this.MostrarCampoProducto('LUGAREXPEDICIONDOCUMENTO') && this.HabilitarCampoProducto('LUGAREXPEDICIONDOCUMENTO')) {
      let validatorsLugarExpedicion = [];
      validatorsLugarExpedicion.push(Validators.required);
      this.form.get('departamentoExpedicionDocumento').setValidators(validatorsLugarExpedicion);
      this.form.get('departamentoExpedicionDocumento').updateValueAndValidity();

      this.form.get('ciudadExpedicionDocumento').setValidators(validatorsLugarExpedicion);
      this.form.get('ciudadExpedicionDocumento').updateValueAndValidity();
    }

    if (this.MostrarCampoProducto('GENERO') && this.HabilitarCampoProducto('GENERO')) {
      let validatorsGenero = [];
      validatorsGenero.push(Validators.required);
      validatorsGenero.push(Validators.min(1));
      this.form.get('genero').setValidators(validatorsGenero);
      this.form.get('genero').updateValueAndValidity();
    }

    if (this.MostrarCampoProducto('TIPOPLAN') && this.HabilitarCampoProducto('TIPOPLAN')) {
      let validatorsTipoPlan = [];
      validatorsTipoPlan.push(Validators.required);
      validatorsTipoPlan.push(Validators.min(1));
      this.form.get('tipoPlan').setValidators(validatorsTipoPlan);
      this.form.get('tipoPlan').updateValueAndValidity();
    }

    if (this.MostrarCampoProducto('PLAN') && this.HabilitarCampoProducto('PLAN')) {
      let validatorsPlan = [];
      validatorsPlan.push(Validators.required);
      validatorsPlan.push(Validators.min(1));
      this.form.get('filtroPlan').setValidators(validatorsPlan);
      this.form.get('filtroPlan').updateValueAndValidity();
    }

    if (this.MostrarCampoProducto('TIPORIESGO') && this.HabilitarCampoProducto('TIPORIESGO')) {
      let validatorsTipoRiesgo = [];
      validatorsTipoRiesgo.push(Validators.required);
      validatorsTipoRiesgo.push(Validators.min(1));
      this.form.get('tipoRiesgo').setValidators(validatorsTipoRiesgo);
      this.form.get('tipoRiesgo').updateValueAndValidity();
    }

    if (this.MostrarCampoProducto('PERIODOPAGO') && this.HabilitarCampoProducto('PERIODOPAGO')) {
      let validatorsPeriodoPago = [];
      validatorsPeriodoPago.push(Validators.required);
      this.form.get('periodoPago').setValidators(validatorsPeriodoPago);
      this.form.get('periodoPago').updateValueAndValidity();
    }
  }
  EstablecerDatosTomadorRequeridos(tomarDatosTomador: boolean = false) {
    this.formTomador.get('nroDocumentoTomador').setValidators([]);
    this.formTomador.get('nroDocumentoTomador').updateValueAndValidity();

    this.formTomador.get('nombresTomador').setValidators([]);
    this.formTomador.get('nombresTomador').updateValueAndValidity();

    this.formTomador.get('apellidosTomador').setValidators([]);
    this.formTomador.get('apellidosTomador').updateValueAndValidity();

    this.formTomador.get('nroMovilTomador').setValidators([]);
    this.formTomador.get('nroMovilTomador').updateValueAndValidity();

    this.formTomador.get('nroFijoTomador').setValidators([]);
    this.formTomador.get('nroFijoTomador').updateValueAndValidity();

    this.formTomador.get('emailTomador').setValidators([]);
    this.formTomador.get('emailTomador').updateValueAndValidity();
    
    this.formTomador.get('edadTomador').setValidators([]);
    this.formTomador.get('edadTomador').updateValueAndValidity();

    if (this.HabilitarCamposTomador() && !tomarDatosTomador) {
      if (this.MostrarCampoProductoConfiguracion('NRODOCUMENTOTOMADOR')) {
        let validatorsNroDocumentoTomador = [];
        validatorsNroDocumentoTomador.push(Validators.required);
        validatorsNroDocumentoTomador.push(Validators.maxLength(20));
        validatorsNroDocumentoTomador.push(Validators.pattern('^[A-Za-z0-9\s]*$'));
        this.formTomador.get('nroDocumentoTomador').setValidators(validatorsNroDocumentoTomador);
        this.formTomador.get('nroDocumentoTomador').updateValueAndValidity();
      }

      if (this.MostrarCampoProductoConfiguracion('NOMBRETOMADOR')) {
        let validatorsNombreTomador = [];
        validatorsNombreTomador.push(Validators.required);
        validatorsNombreTomador.push(Validators.maxLength(100));
        this.formTomador.get('nombresTomador').setValidators(validatorsNombreTomador);
        this.formTomador.get('nombresTomador').updateValueAndValidity();
      }
      
      if (this.MostrarCampoProductoConfiguracion('APELLIDOTOMADOR')) {
        let validatorsApellidosTomador = [];
        validatorsApellidosTomador.push(Validators.required);
        validatorsApellidosTomador.push(Validators.maxLength(100));
        this.formTomador.get('apellidosTomador').setValidators(validatorsApellidosTomador);
        this.formTomador.get('apellidosTomador').updateValueAndValidity();
      }

      if (this.MostrarCampoProductoConfiguracion('NROMOVILTOMADOR')) {
        let validatorsNroMovilTomador = [];
        validatorsNroMovilTomador.push(Validators.required);
        validatorsNroMovilTomador.push(Validators.maxLength(20));
        this.formTomador.get('nroMovilTomador').setValidators(validatorsNroMovilTomador);
        this.formTomador.get('nroMovilTomador').updateValueAndValidity();
      }

      if (this.MostrarCampoProductoConfiguracion('NROFIJOTOMADOR')) {
        let validatorsNroFijoTomador = [];
        validatorsNroFijoTomador.push(Validators.maxLength(20));
        this.formTomador.get('nroFijoTomador').setValidators(validatorsNroFijoTomador);
        this.formTomador.get('nroFijoTomador').updateValueAndValidity();
      }

      if (this.MostrarCampoProductoConfiguracion('EMAILTOMADOR')) {
        let validatorsEmailTomador = [];
        validatorsEmailTomador.push(Validators.required);
        validatorsEmailTomador.push(Validators.maxLength(40));
        validatorsEmailTomador.push(Validators.email);
        this.formTomador.get('emailTomador').setValidators(validatorsEmailTomador);
        this.formTomador.get('emailTomador').updateValueAndValidity();
      }

      if (this.MostrarCampoProductoConfiguracion('CIUDADTOMADOR')) {
        if (this.registrarDomicilio || (this.MostrarCampoProducto('CIUDAD') && this.HabilitarCampoProducto('CIUDAD'))) {
          let validatorsDomicilio = [];
          validatorsDomicilio.push(Validators.required);
          this.formTomador.get('idDepartamentoTomador').setValidators(validatorsDomicilio);
          this.formTomador.get('idDepartamentoTomador').updateValueAndValidity();
    
          this.formTomador.get('idCiudadTomador').setValidators(validatorsDomicilio);
          this.formTomador.get('idCiudadTomador').updateValueAndValidity();
        }
      }

      if (this.MostrarCampoProductoConfiguracion('DIRECCIONTOMADOR')) {
        if (this.registrarDomicilio || (this.MostrarCampoProducto('DIRECCION') && this.HabilitarCampoProducto('DIRECCION'))) {
          let validatorsDomicilio = [];
          validatorsDomicilio.push(Validators.required);
          validatorsDomicilio.push(Validators.maxLength(60));
          this.formTomador.get('domicilioTomador').setValidators(validatorsDomicilio);
          this.formTomador.get('domicilioTomador').updateValueAndValidity();
        }
      }
      
    }

    if (this.HabilitarCamposTomador() && this.registrarFechaNacimiento && this.MostrarCampoProductoConfiguracion('FECHANACIMIENTOTOMADOR')) {
      if (this.utilitariosService.VerificarContieneDatos(this.listaEdadesNacimiento)) {
        let edadMinima: number = 0;
        let edadMaxima: number = 1000;

        let listaEdadFiltro = this.listaEdadesNacimiento.filter(x => x.id === this.form.get('idProducto').value);
        if (listaEdadFiltro) {
          if (listaEdadFiltro.length > 0) {
            if (listaEdadFiltro[0].condicionEntero3 > 0) {
              edadMinima = listaEdadFiltro[0].condicionEntero3;
            }
            if (listaEdadFiltro[0].condicionEntero4 > 0) {
              edadMaxima = listaEdadFiltro[0].condicionEntero4;
            }
          }
        }

        this.edadMinimaTomador = edadMinima;
        this.edadMaximaTomador = edadMaxima;
      }

      let validatorsEdad = [];
      validatorsEdad.push(Validators.required);
      validatorsEdad.push(Validators.min(this.edadMinimaTomador));
      validatorsEdad.push(Validators.max(this.edadMaximaTomador));
      this.formTomador.get('edadTomador').setValidators(validatorsEdad);
      this.formTomador.get('edadTomador').updateValueAndValidity();
    }
  }
  EstablecerDatosAdicionalesRequeridosBeneficiario() {
    this.formBeneficiados.get('nroDocumento').setValidators([]);
    this.formBeneficiados.get('nroDocumento').updateValueAndValidity();

    this.formBeneficiados.get('nombres').setValidators([]);
    this.formBeneficiados.get('nombres').updateValueAndValidity();

    this.formBeneficiados.get('apellidos').setValidators([]);
    this.formBeneficiados.get('apellidos').updateValueAndValidity();

    this.formBeneficiados.get('parentesco').setValidators([]);
    this.formBeneficiados.get('parentesco').updateValueAndValidity();

    this.formBeneficiados.get('parentescoDescripcion').setValidators([]);
    this.formBeneficiados.get('parentescoDescripcion').updateValueAndValidity();

    this.formBeneficiados.get('participacion').setValidators([]);
    this.formBeneficiados.get('participacion').updateValueAndValidity();

    this.formBeneficiados.get('tipoBeneficiario').setValidators([]);
    this.formBeneficiados.get('tipoBeneficiario').updateValueAndValidity();

    this.formBeneficiados.get('tipoIdentificacion').setValidators([]);
    this.formBeneficiados.get('tipoIdentificacion').updateValueAndValidity();

    this.formBeneficiados.get('raza').setValidators([]);
    this.formBeneficiados.get('raza').updateValueAndValidity();

    this.formBeneficiados.get('nacimiento').setValidators([]);
    this.formBeneficiados.get('nacimiento').updateValueAndValidity();

    this.formBeneficiados.get('color').setValidators([]);
    this.formBeneficiados.get('color').updateValueAndValidity();

    this.formBeneficiados.get('genero').setValidators([]);
    this.formBeneficiados.get('genero').updateValueAndValidity();

    this.formBeneficiados.get('edad').setValidators([]);
    this.formBeneficiados.get('edad').updateValueAndValidity();

    if (this.MostrarCampoBeneficiario('nroDocumento')) {
      let validatorsAdicionar = [];
      validatorsAdicionar.push(Validators.required);
      validatorsAdicionar.push(Validators.maxLength(20));
      this.formBeneficiados.get('nroDocumento').setValidators(validatorsAdicionar);
      this.formBeneficiados.get('nroDocumento').updateValueAndValidity();
    }
    if (this.MostrarCampoBeneficiario('nombres')) {
      let validatorsAdicionar = [];
      validatorsAdicionar.push(Validators.required);
      validatorsAdicionar.push(Validators.maxLength(100));
      this.formBeneficiados.get('nombres').setValidators(validatorsAdicionar);
      this.formBeneficiados.get('nombres').updateValueAndValidity();
    }
    if (this.MostrarCampoBeneficiario('apellidos')) {
      let validatorsAdicionar = [];
      validatorsAdicionar.push(Validators.required);
      validatorsAdicionar.push(Validators.maxLength(100));
      this.formBeneficiados.get('apellidos').setValidators(validatorsAdicionar);
      this.formBeneficiados.get('apellidos').updateValueAndValidity();
    }
    if (this.MostrarCampoBeneficiario('parentesco')) {
      let validatorsAdicionar = [];
      validatorsAdicionar.push(Validators.required);
      validatorsAdicionar.push(Validators.min(1));
      this.formBeneficiados.get('parentesco').setValidators(validatorsAdicionar);
      this.formBeneficiados.get('parentesco').updateValueAndValidity();
    }
    if (this.MostrarCampoBeneficiario('participacion')) {
      let validatorsAdicionar = [];
      validatorsAdicionar.push(Validators.required);
      validatorsAdicionar.push(Validators.max(100));
      this.formBeneficiados.get('participacion').setValidators(validatorsAdicionar);
      this.formBeneficiados.get('participacion').updateValueAndValidity();
    }
    if (this.MostrarCampoBeneficiario('tipoBeneficiario')) {
      let validatorsAdicionar = [];
      validatorsAdicionar.push(Validators.required);
      validatorsAdicionar.push(Validators.min(1));
      this.formBeneficiados.get('tipoBeneficiario').setValidators(validatorsAdicionar);
      this.formBeneficiados.get('tipoBeneficiario').updateValueAndValidity();
    }
    if (this.MostrarCampoBeneficiario('tipoIdentificacion')) {
      let validatorsAdicionar = [];
      validatorsAdicionar.push(Validators.required);
      this.formBeneficiados.get('tipoIdentificacion').setValidators(validatorsAdicionar);
      this.formBeneficiados.get('tipoIdentificacion').updateValueAndValidity();
    }
    if (this.MostrarCampoBeneficiario('raza')) {
      let validatorsAdicionar = [];
      validatorsAdicionar.push(Validators.required);
      validatorsAdicionar.push(Validators.maxLength(100));
      this.formBeneficiados.get('raza').setValidators(validatorsAdicionar);
      this.formBeneficiados.get('raza').updateValueAndValidity();
    }
    if (this.MostrarCampoBeneficiario('nacimiento')) {
      let validatorsAdicionar = [];
      validatorsAdicionar.push(Validators.required);
      this.formBeneficiados.get('nacimiento').setValidators(validatorsAdicionar);
      this.formBeneficiados.get('nacimiento').updateValueAndValidity();
    }
    if (this.MostrarCampoBeneficiario('color')) {
      let validatorsAdicionar = [];
      validatorsAdicionar.push(Validators.required);
      this.formBeneficiados.get('color').setValidators(validatorsAdicionar);
      this.formBeneficiados.get('color').updateValueAndValidity();
    }
    if (this.MostrarCampoBeneficiario('genero')) {
      let validatorsAdicionar = [];
      validatorsAdicionar.push(Validators.required);
      validatorsAdicionar.push(Validators.min(1));
      this.formBeneficiados.get('genero').setValidators(validatorsAdicionar);
      this.formBeneficiados.get('genero').updateValueAndValidity();
    }

    if (this.MostrarCampoBeneficiario('edad')) {
      let validatorsEdad = [];
      validatorsEdad.push(Validators.required);
      validatorsEdad.push(Validators.min(this.edadMinima));
      validatorsEdad.push(Validators.max(this.edadMaxima));
      this.formBeneficiados.get('edad').setValidators(validatorsEdad);
      this.formBeneficiados.get('edad').updateValueAndValidity();
    }
  }
  EstablecerDatosAdicionalesRequeridosInformacionVehiculo() {
    this.formInformacionVehiculo.get('modelo').setValidators([]);
    this.formInformacionVehiculo.get('modelo').updateValueAndValidity();

    let cantidadAnnosMaximo: number = this.AnnoMinimoModelo();

    let validatorsAdicionar = [];
    validatorsAdicionar.push(Validators.max(9999));

    if (cantidadAnnosMaximo > 0) {
      validatorsAdicionar.push(Validators.min(cantidadAnnosMaximo));
    } else {
      validatorsAdicionar.push(Validators.min(1));
    }

    this.formInformacionVehiculo.get('modelo').setValidators(validatorsAdicionar);
    this.formInformacionVehiculo.get('modelo').updateValueAndValidity();
  }

  CargarListasIniciales() {
    this.listaDepartamentos = this.configuracionService.ListasSistema.filter(x => x.lista === Constantes.LISTAS_PROVINCIAS());
    this.listaConfiguracionCampos = this.configuracionService.ListasSistema.filter(x => x.lista === Constantes.LISTAS_PRODUCTOSCAMPOS());
    this.listaTiposIdentificacion = this.configuracionService.ListasSistema.filter(x => x.lista === Constantes.LISTAS_TIPOSIDENTIFICACION());
    this.listaGeneros = this.configuracionService.ListasSistema.filter(x => x.lista === Constantes.LISTAS_GENEROS());
    this.listaTipoRiesgo = this.configuracionService.ListasSistema.filter(x => x.lista === Constantes.LISTAS_PRODUCTOSTIPORIESGO());
    this.listaCamposBeneficiarios = this.configuracionService.ListasSistema.filter(x => x.lista === Constantes.LISTAS_PRODUCTOSBENEFICIARIOSCAMPOS());
    this.listaProductosOcultarBeneficiarios = this.configuracionService.ListasSistema.filter(x => x.lista === Constantes.LISTAS_OCULTARBENEFICIARIOS());
    this.listaProductosBeneficiariosRequeridos = this.configuracionService.ListasSistema.filter(x => x.lista === Constantes.LISTAS_PRODUCTOSBENEFICIARIOSREQUERIDOS());
    this.listaPeriodosPago = this.configuracionService.ListasSistema.filter(x => x.lista === Constantes.LISTAS_PERIODOSPAGO());
    this.listaEdadesNacimiento = this.configuracionService.ListasSistema.filter(x => x.lista === Constantes.LISTAS_EDADESNACIMIENTO());
    this.listaProductosTomador = this.configuracionService.ListasSistema.filter(x => x.lista === Constantes.LISTAS_PRODUCTOS_TOMADOR());
    this.listaProductosAnnosModelo = this.configuracionService.ListasSistema.filter(x => x.lista === Constantes.LISTAS_PRODUCTOS_ANNOS_MODELO());
  }
  CargarListaCiudades(idDependencia: string) {
    let listaCiudades: Listas[] = [];
    let listaFiltradaCiudades = this.configuracionService.ListasSistema.filter(x => x.lista === Constantes.LISTAS_CIUDADES());
    for (let index = 0; index < listaFiltradaCiudades.length; index++) {
      if (listaFiltradaCiudades[index].dependenciaCodigo === idDependencia) {
        listaCiudades.push(listaFiltradaCiudades[index]);
      }
    }
    this.listaCiudades = listaCiudades;
  }
  CargarListaCiudadesExpedicion(idDependencia: string) {
    let listaCiudades: Listas[] = [];
    let listaFiltradaCiudades = this.configuracionService.ListasSistema.filter(x => x.lista === Constantes.LISTAS_CIUDADES());
    for (let index = 0; index < listaFiltradaCiudades.length; index++) {
      if (listaFiltradaCiudades[index].dependenciaCodigo === idDependencia) {
        listaCiudades.push(listaFiltradaCiudades[index]);
      }
    }
    this.listaCiudadesExpedicion = listaCiudades;
  }
  CargarListaCiudadesTomador(idDependencia: string) {
    let listaCiudadesTomador: Listas[] = [];
    let listaFiltradaCiudades = this.configuracionService.ListasSistema.filter(x => x.lista === Constantes.LISTAS_CIUDADES());
    for (let index = 0; index < listaFiltradaCiudades.length; index++) {
      if (listaFiltradaCiudades[index].dependenciaCodigo === idDependencia) {
        listaCiudadesTomador.push(listaFiltradaCiudades[index]);
      }
    }
    this.listaCiudadesTomador = listaCiudadesTomador;
  }
  CrearAfiliado() {
    this.CambioTomadorIgualAsegurado(false);
    setTimeout(() => {
      this.ContinuarCrearAfiliado(); 
    });
  }
  ContinuarCrearAfiliado() {
    let continuarGuardado: boolean = true;
    console.log('CrearAfiliado', this.form);
    console.log('CrearAfiliado-ListaBeneficiarios', this.listaDatosBeneficiados);
    console.log('CrearAfiliado-Tomador', this.formTomador);
    console.log('CrearAfiliado-InformacionVehiculo', this.formInformacionVehiculo);

    if (!this.form.valid) {
      this.utilitariosService.MostrarErroresFormulario(this.form);
      this._tabGroup.selectedIndex = 0;
      continuarGuardado = false;
    } else {
      if (this.BeneficiariosRequeridos()) {
        if (this.listaDatosBeneficiados) {
          if (this.listaDatosBeneficiados.length === 0) {
            this.utilitariosService.MensajeToast('Es necesario realizar el registro de los beneficiarios.');
            this._tabGroup.selectedIndex = 1;
            continuarGuardado = false;
          }
        } else {
          this.utilitariosService.MensajeToast('Es necesario realizar el registro de los beneficiarios.');
          this._tabGroup.selectedIndex = 1;
          continuarGuardado = false;
        }
      }

      if (continuarGuardado) {
        if (this.HabilitarCamposTomador()) {
          if (!this.formTomador.valid) {
            this.utilitariosService.MostrarErroresFormulario(this.formTomador);
            if (this.registrarBenefiarios && this.BeneficiariosRequeridos()) {
              this._tabGroup.selectedIndex = 2;
            } else {
              this._tabGroup.selectedIndex = 1;
            }
            continuarGuardado = false;
          }
        }
      }

      if (continuarGuardado) {
        if (this.MostrarTabVehiculo()) {
          if (!this.formInformacionVehiculo.valid) {
            this.utilitariosService.MostrarErroresFormulario(this.formInformacionVehiculo);
            if (this.registrarBenefiarios && this.BeneficiariosRequeridos()) {
              if (this.HabilitarCamposTomador()) {
                this._tabGroup.selectedIndex = 3;
              } else {
                this._tabGroup.selectedIndex = 2;
              }
            } else {
              if (this.HabilitarCamposTomador()) {
                this._tabGroup.selectedIndex = 2;
              } else {
                this._tabGroup.selectedIndex = 1;
              }
            }
            continuarGuardado = false;
          }
        }
      }
    }

    if (continuarGuardado) {
      this.codigoAccion = 'guardar';
      this._appconfirmacion.MostrarMensajeConfirmacion();
    }
  }
  ConfirmarGuardado() {
    this.mostrarCargando = true;
    this.form.get('tomadorIgualAsegurado').setValue(this.formTomador.get('tomadorIgualAsegurado').value);
    this.form.get('nroDocumentoTomador').setValue(this.formTomador.get('nroDocumentoTomador').value);
    this.form.get('nombresTomador').setValue(this.formTomador.get('nombresTomador').value);
    this.form.get('apellidosTomador').setValue(this.formTomador.get('apellidosTomador').value);
    this.form.get('nroMovilTomador').setValue(this.formTomador.get('nroMovilTomador').value);
    this.form.get('nroFijoTomador').setValue(this.formTomador.get('nroFijoTomador').value);
    this.form.get('emailTomador').setValue(this.formTomador.get('emailTomador').value);
    this.form.get('domicilioTomador').setValue(this.formTomador.get('domicilioTomador').value);
    this.form.get('idDepartamentoTomador').setValue(this.formTomador.get('idDepartamentoTomador').value);
    this.form.get('idCiudadTomador').setValue(this.formTomador.get('idCiudadTomador').value);
    this.form.get('nacimientoTomador').setValue(this.formTomador.get('nacimientoTomador').value);
    this.form.get('edadTomador').setValue(this.formTomador.get('edadTomador').value);

    if (this.listaMarcas.filter(x => x.descripcion === this.formInformacionVehiculo.get('marcaDescripcion')?.value).length > 0) {
      this.formInformacionVehiculo.get('marca').setValue(this.listaMarcas.filter(x => x.descripcion === this.formInformacionVehiculo.get('marcaDescripcion')?.value)[0].id);
    }

    if (this.listaMarcasRefecencias.filter(x => x.descripcion === this.formInformacionVehiculo.get('referenciaDescripcion')?.value).length > 0) {
      this.formInformacionVehiculo.get('referencia').setValue(this.listaMarcasRefecencias.filter(x => x.descripcion === this.formInformacionVehiculo.get('referenciaDescripcion')?.value)[0].id);
    }

    this.form.get('marca').setValue(this.formInformacionVehiculo.get('marca').value);
    this.form.get('marcaDescripcion').setValue(this.formInformacionVehiculo.get('marcaDescripcion').value);
    this.form.get('referencia').setValue(this.formInformacionVehiculo.get('referencia').value);
    this.form.get('referenciaDescripcion').setValue(this.formInformacionVehiculo.get('referenciaDescripcion').value);
    this.form.get('modelo').setValue(this.formInformacionVehiculo.get('modelo').value);
    this.form.get('placa').setValue(this.formInformacionVehiculo.get('placa').value);


    this.form.get('listaBeneficiados').setValue(this.listaDatosBeneficiados);
    this.form.get('listaBeneficiadosEliminar').setValue(this.listaDatosBeneficiadosEliminar);

    let listaDocumentosEliminar = this.listaDatosDocumentos.filter(item2 => !this.listaDatosDocumentosUsuario.some(item1 => item1.id === item2.id));
    this.form.get('listaDocumentosEliminar').setValue(listaDocumentosEliminar);

    this.productosService.Afiliado_Crear(this.form.value)
            .subscribe((resp: RespuestaGenerica) =>{
              if (!resp.procesoExitoso) {
                this.mostrarCargando = false;
                this.utilitariosService.MensajeToast(resp.mensaje);
              } else if (this.utilitariosService.VerificarContieneDatosLista(this.listaDatosDocumentosUsuario)) {
                if (this.listaDatosDocumentosUsuario.filter(x => this.utilitariosService.VerificarContieneDatos(x.archivo)).length > 0) {
                  this.SubirArchivosAfiliado(resp.id, resp.idAdicional);
                } else {
                  this.mostrarCargando = false;
                  this.FinalizarCreacionAfiliado(resp.id, resp.idAdicional);
                }
              } else {
                this.mostrarCargando = false;
                this.FinalizarCreacionAfiliado(resp.id, resp.idAdicional);
              }
            },
            (error: Error) => {
              this.utilitariosService.ObtenerMensajeErrorRespuesta(error);
              this.mostrarCargando = false;
              this.cd.detectChanges();
            },
            () => this.cd.detectChanges());
  }
  SubirArchivosAfiliado(idCliente: number, idClienteProducto: number) {
    let cantidadArchivos: number = this.listaDatosDocumentosUsuario.length;
    for (let index = 0; index < cantidadArchivos; index++) {
      let itemDocumento = this.listaDatosDocumentosUsuario[index];

      if (this.utilitariosService.VerificarContieneDatos(itemDocumento.archivo)) {
        let formData = new FormData();
        formData.append('formFiles', itemDocumento.archivo);
        let complementoUrl: string = `${this.form.get('idAliado')?.value}/${this.form.get('idProducto')?.value}/${idCliente}/${idClienteProducto}/${itemDocumento.id}/${itemDocumento.orden}`;
  
        this.productosService.Afiliado_SubirArchivos(formData, complementoUrl)
          .subscribe((resp: RespuestaGenerica) => {
            if ((index + 1) === this.listaDatosDocumentosUsuario.length) {
              this.mostrarCargando = false;
              this.FinalizarCreacionAfiliado(idCliente, idClienteProducto);
            }
          },
          (error: Error) => {
            this.utilitariosService.ObtenerMensajeErrorRespuesta(error);
            this.mostrarCargando = false;
            this.cd.detectChanges();
          },
          () => this.cd.detectChanges());
      }
    }
  }
  FinalizarCreacionAfiliado(idCliente: number, idClienteProducto: number) {
    if (this.esEdicionRegistro) {
      let itemNotificacion: GestionAfiliado_Parametro = new GestionAfiliado_Parametro();
      itemNotificacion.nroDocumento = this.filtroPantallaGestionAfiliado;
      itemNotificacion.nombres = '';
      itemNotificacion.consultarDatos = true;
      this.menuService.CambiarComponenteActivo('GestionAfiliadosComponent', JSON.stringify(itemNotificacion));
    } else {
      let registroNotificar: RegistroAfiliado = JSON.parse(JSON.stringify(this.form.value));
      registroNotificar.valorProducto = idClienteProducto.toString();
      registroNotificar.id = idCliente;
      registroNotificar.notificarCambios = this.notificarCambios;

      this.menuService.CambiarComponenteActivo('ConfirmAfiliacionComponent', JSON.stringify(registroNotificar));
    }
  }
  ConsultarNroDocumento(event: any) {
    let nroDocumento: string = event.target.value;
    if (nroDocumento !== '' && nroDocumento !== null && nroDocumento !== undefined) {
      this.mostrarCargando = true;
      let formConsulta = this.fb.group({
        idAplicacion: 0,
        nroDocumento: ''
      });
      formConsulta.get('idAplicacion').setValue(this.autenticacionService.AplicacionSeleccionado);
      formConsulta.get('nroDocumento').setValue(nroDocumento);
      this.productosService.ConsultarNroDocumento(formConsulta.value)
                .subscribe((resp: ClientesProspecto[]) =>{
                  this.mostrarCargando = false;
                  if (resp.length > 0) {
                    this.form.get('nombres').setValue(resp[0].nombres);
                    this.form.get('apellidos').setValue(resp[0].apellidos);
                    this.form.get('nroMovil').setValue(resp[0].nroMovil);
                    this.form.get('nroFijo').setValue(resp[0].nroFijo);
                    this.form.get('email').setValue(resp[0].email);
                    this.form.get('domicilio').setValue(resp[0].domicilio);
                    this.form.get('idDepartamento').setValue(resp[0].idDepartamento);
                    this.form.get('idCiudad').setValue(resp[0].idCiudad);
                    this.form.get('nacimiento').setValue(resp[0].nacimiento);
                  }
                },
                (error: Error) => {
                  this.utilitariosService.ObtenerMensajeErrorRespuesta(error);
                  this.mostrarCargando = false;
                  this.cd.detectChanges();
                },
                () => this.cd.detectChanges());
    }
  }
  CancelarRegistro() {
    this.menuService.CambiarComponenteActivo(this.autenticacionService.Componente);
  }
  ConfirmoUsuario(confirmo: boolean) {
    if (confirmo) {
      if (this.codigoAccion === 'guardar') {
        this.ConfirmarGuardado();
      } else {
        this.EliminarRegistroBeneficiado();
      }
    } else {
      if (this.codigoAccion === 'guardar') {
        this.CambioTomadorIgualAsegurado();
      }
    }
  }
  CargarListaPlazosProducto(idProducto: number) {
    let listaPlazosProducto: Listas[] = [];
    let listaFiltrada = this.configuracionService.ListasSistema.filter(x => x.lista === Constantes.LISTAS_PRODUCTOSPLAZOS());
    for (let index = 0; index < listaFiltrada.length; index++) {
      if (listaFiltrada[index].dependienciaId === idProducto) {
        listaPlazosProducto.push(listaFiltrada[index]);
      }
    }
    this.listaPlazoProducto = listaPlazosProducto;

    if (this.listaPlazoProducto.length === 1) {
      this.form.get('idProductoPlazo').setValue(this.listaPlazoProducto[0].id);
    }
  }
  ConsultarListaProductosEdades() {
    let parametrosConsulta = this.fb.group({
      idAplicacion: [0]
      ,idAliado: [0]
    });
    parametrosConsulta.get('idAplicacion').setValue(this.autenticacionService.AplicacionSeleccionado);
    parametrosConsulta.get('idAliado').setValue(this.autenticacionService.AliadoSeleccionado);
    this.gestionAfiliadoService.ConsultarProductosEdades(parametrosConsulta.value)
                .subscribe((resp: ProductosEdades[]) =>{
                  this.listaProductosEdades = resp;
                },
                (error: Error) => {
                  this.utilitariosService.ObtenerMensajeErrorRespuesta(error);
                  this.mostrarCargando = false;
                  this.cd.detectChanges();
                },
                () => this.cd.detectChanges());
  }
  ConsultarListaEstados() {
    let parametrosConsulta = this.fb.group({
      idAplicacion: [0]
      ,idAliado: [0]
    });
    parametrosConsulta.get('idAplicacion').setValue(this.autenticacionService.AplicacionSeleccionado);
    parametrosConsulta.get('idAliado').setValue(this.autenticacionService.AliadoSeleccionado);
    this.gestionAfiliadoService.ConsultarEstados(parametrosConsulta.value)
                .subscribe((resp: Estados[]) =>{
                  this.listaEstados = resp.filter(x => x.defecto);
                  this.VerificarEstadoDefecto();
                },
                (error: Error) => {
                  this.utilitariosService.ObtenerMensajeErrorRespuesta(error);
                  this.mostrarCargando = false;
                  this.cd.detectChanges();
                },
                () => this.cd.detectChanges());
  }
  ConsultarListaParentescos(idProducto: number) {
    let parametrosConsulta = this.fb.group({
      idAplicacion: [0]
      ,idAliado: [0]
      ,idProducto: [0]
    });
    parametrosConsulta.get('idAplicacion').setValue(this.autenticacionService.AplicacionSeleccionado);
    parametrosConsulta.get('idAliado').setValue(this.autenticacionService.AliadoSeleccionado);
    parametrosConsulta.get('idProducto').setValue(idProducto);
    this.gestionAfiliadoService.ConsultarParentescos(parametrosConsulta.value)
                .subscribe((resp: Parentescos[]) =>{
                  this.listaParentescos = resp;

                  this.EstablecerDatosEdicionRegistroBeneficiarios();
                },
                (error: Error) => {
                  this.utilitariosService.ObtenerMensajeErrorRespuesta(error);
                  this.mostrarCargando = false;
                  this.cd.detectChanges();
                },
                () => this.cd.detectChanges());
  }
  ConsultarDatosAdicionalesAliado(idProducto: number) {
    let parametrosConsulta = this.fb.group({
      idAplicacion: [0]
      ,idAliado: [0]
      ,idProducto: [0]
      ,tipoNotificacion: ['R']
    });
    parametrosConsulta.get('idAplicacion').setValue(this.autenticacionService.AplicacionSeleccionado);
    parametrosConsulta.get('idAliado').setValue(this.autenticacionService.AliadoSeleccionado);
    parametrosConsulta.get('idProducto').setValue(idProducto);
    
    this.productosService.ConsultarDatosAdicionalesAliado(parametrosConsulta.value)
                .subscribe((resp: AliadoDatosAdicionales) =>{
                  this.registrarEstado = resp.registrarEstado;
                  this.calculoPrecioEdad = resp.calculoPrecioEdad;
                  this.registrarBenefiarios = resp.registrarBeneficiarios;
                  this.beneficiariosRequerido = resp.beneficiariosRequerido;
                  this.notificarCambios = resp.notificarCambios;
                  this.registrarFechaNacimiento = resp.manejaFechaNacimiento;
                  this.registrarDomicilio = resp.manejaDomicilio;
                  this.registrarObservaciones = resp.manejaObservaciones;

                  this.EstablecerDatosAdicionalesRequeridos();
                  this.VerificarEstadoDefecto();
                },
                (error: Error) => {
                  this.utilitariosService.ObtenerMensajeErrorRespuesta(error);
                  this.mostrarCargando = false;
                  this.cd.detectChanges();
                },
                () => this.cd.detectChanges());
  }
  CargarListaProductosEdad(idProducto: number) {
    if (this.utilitariosService.VerificarContieneDatos(this.listaProductosEdades)) {
      this.listaProductosEdadesFiltrada = this.listaProductosEdades.filter(x => x.producto === idProducto);
      this.EstablecerDatosAdicionalesRequeridos();
    }
  }
  AsignarProductoEdad(edad: number) {
    this.form.get('idProductoEdad').setValue(0);
    this.form.get('idProductoEdadDescripcion').setValue('');
    if (this.utilitariosService.VerificarContieneDatos(this.listaProductosEdadesFiltrada)) {
      if (this.listaProductosEdadesFiltrada.filter(x => x.inicio <= edad && x.fin >= edad).length > 0) {
        this.form.get('idProductoEdad').setValue(this.listaProductosEdadesFiltrada.filter(x => x.inicio <= edad && x.fin >= edad)[0].id);
        this.form.get('idProductoEdadDescripcion').setValue(this.listaProductosEdadesFiltrada.filter(x => x.inicio <= edad && x.fin >= edad)[0].descripcion);
      }
    }
  }
  VerificarEstadoDefecto() {
    if (this.utilitariosService.VerificarContieneDatos(this.listaEstados)) {
      if (this.listaEstados.length > 0) {
        this.form.get('idEstado').setValue(this.listaEstados[0].id);
      }
    }
  }
  recargarListaBeneficiados() {
    this.dataSourceBeneficiados = new MatTableDataSource(this.listaDatosBeneficiados);
    this.dataSourceBeneficiados.paginator = this.paginator;
    this.dataSourceBeneficiados.sort = this.sort;
  }
  NuevoBeneficiados() {
    this.editarRegistroBeneficiados = true;
    this.IniciarFormularioBeneficiado();
    this.formBeneficiados.get('id').setValue((this.listaDatosBeneficiados.length + 1) * -1);
  }
  EditarBeneficiado(parametroEditar: GestionAfiliado_Beneficiados) {
    this.editarRegistroBeneficiados = true;
    this.formBeneficiados.setValue(parametroEditar);
  }
  EliminarBeneficiado(parametroEditar: GestionAfiliado_Beneficiados) {
    this.detalleSeleccionado = parametroEditar.id;
    this.detalleSeleccionadoBeneficiario = parametroEditar;
    this.codigoAccion = 'eliminarBeneficiado';
    this._appconfirmacion.MostrarMensajeConfirmacion();
  }
  GuardarBeneficiado() {
    if (this.utilitariosService.VerificarContieneDatosLista(this.listaCamposBeneficiariosProducto)) {
      for (let index = 0; index < this.listaCamposBeneficiariosProducto.length; index++) {
        let item = this.listaCamposBeneficiariosProducto[index];
        if (this.utilitariosService.VerificarContieneDatosTexto(item.dependenciaCodigo)) {
          if (this.utilitariosService.VerificarContieneDatosTexto(this.form.get(item.dependenciaCodigo).value)) {
            this.formBeneficiados.get(item.codigo).setValue(this.form.get(item.dependenciaCodigo).value);
          }
        }
      }
    }

    if (this.formBeneficiados.valid) {
      this.editarRegistroBeneficiados = false;
      if (this.listaDatosBeneficiados.filter(x => x.id === this.formBeneficiados.get('id').value).length > 0) {
        let parametroActualizar = this.listaDatosBeneficiados.filter(x => x.id === this.formBeneficiados.get('id').value)[0];
        parametroActualizar.nroDocumento = this.formBeneficiados.get('nroDocumento').value;
        parametroActualizar.nombres = this.formBeneficiados.get('nombres').value;
        parametroActualizar.apellidos = this.formBeneficiados.get('apellidos').value;
        parametroActualizar.parentesco = this.formBeneficiados.get('parentesco').value;
        parametroActualizar.parentescoDescripcion = this.formBeneficiados.get('parentescoDescripcion').value;
        parametroActualizar.participacion = this.formBeneficiados.get('participacion').value;
        parametroActualizar.tipoBeneficiario = this.formBeneficiados.get('tipoBeneficiario').value;
        parametroActualizar.tipoBeneficiarioDescripcion = this.formBeneficiados.get('tipoBeneficiarioDescripcion').value;
        parametroActualizar.tipoIdentificacion = this.formBeneficiados.get('tipoIdentificacion').value;
        parametroActualizar.tipoIdentificacionDescripcion = this.formBeneficiados.get('tipoIdentificacionDescripcion').value;
        parametroActualizar.raza = this.formBeneficiados.get('raza').value;
        parametroActualizar.nacimiento = this.formBeneficiados.get('nacimiento').value;
        parametroActualizar.edad = this.formBeneficiados.get('edad').value;
        parametroActualizar.color = this.formBeneficiados.get('color').value;
        parametroActualizar.genero = this.formBeneficiados.get('genero').value;
        parametroActualizar.generoDescripcion = this.formBeneficiados.get('generoDescripcion').value;
      } else {
        this.listaDatosBeneficiados.push(this.formBeneficiados.value);
      }
      
      this.recargarListaBeneficiados();
    } else {
      this.utilitariosService.MostrarErroresFormulario(this.formBeneficiados);
    }
  }
  CancelarEditarBeneficiado() {
    this.editarRegistroBeneficiados = false;
  }
  EliminarRegistroBeneficiado() {
    if (this.detalleSeleccionado > 0) {
      this.listaDatosBeneficiados.push(this.listaDatosBeneficiados.filter(x => x.id === this.detalleSeleccionado)[0]);
      this.listaDatosBeneficiadosEliminar.push(this.detalleSeleccionadoBeneficiario);
    }
    let listaNueva: GestionAfiliado_Beneficiados[] = [];
    for (let index = 0; index < this.listaDatosBeneficiados.length; index++) {
      if (this.listaDatosBeneficiados[index].id !== this.detalleSeleccionado) {
        listaNueva.push(this.listaDatosBeneficiados[index]);
      }
    }
    this.listaDatosBeneficiados = listaNueva;
    this.recargarListaBeneficiados();
  }
  ConsultarRegistrosPorcentajesBeneficiarios() {
    let formConsulta: FormGroup = new FormGroup({
      'id': new FormControl(0)
    });
    formConsulta.get('id').setValue(this.autenticacionService.AliadoSeleccionado);
    this.datosPorcentajesBeneficiariosServices.Consultar(formConsulta.value)
              .subscribe((resp: Maestro_AliadosPorcentajeBeneficiarios[]) =>{
                this.listaPorcentajesBeneficiarios = resp;
              },
              (error: Error) => {
                this.utilitariosService.ObtenerMensajeErrorRespuesta(error);
                this.mostrarCargando = false;
                this.cd.detectChanges();
              },
              () => this.cd.detectChanges());
  }
  CargarProductosRegistro() {
    this.mostrarCargando = true;
    let formConsulta = this.fb.group({
      idAplicacion: 0,
      idCanal: 0,
      canal: ''
    });

    formConsulta.get('idAplicacion').setValue(this.autenticacionService.AplicacionSeleccionado);
    formConsulta.get('idCanal').setValue(this.autenticacionService.CanalSeleccionado);
    formConsulta.get('canal').setValue(this.autenticacionService.DescripcionCanalSeleccionado);

    this.productosService.CargarProductosVentas(formConsulta.value).subscribe((resp: Producto[]) => {
      this.productosService.ListaProductosRegistro = resp;
      this.mostrarCargando = false;
      
      setTimeout(() => {
        this.EstablecerDatosEdicionRegistroProducto(); 
      });
    },(error: Error) => {
      this.utilitariosService.ObtenerMensajeErrorRespuesta(error);
      this.mostrarCargando = false;
      this.cd.detectChanges();
    },
    () => this.cd.detectChanges());
  }
  TieneListaPorcentajes(): boolean {
    if (this.listaPorcentajesBeneficiarios) {
      if (this.listaPorcentajesBeneficiarios.length > 0) {
        return true;
      }
    }
    return false;
  }
  MostrarCampoProducto(tipoCampo: string): boolean {
    return this.listaConfiguracionCampos.filter(x => x.dependienciaId === this.form.get('idProducto').value && x.codigo === tipoCampo && x.condicionLogica1).length > 0;
  }
  HabilitarCampoProducto(tipoCampo: string): boolean {
    return this.listaConfiguracionCampos.filter(x => x.dependienciaId === this.form.get('idProducto').value && x.codigo === tipoCampo && x.condicionLogica2).length > 0;
  }
  MostrarCampoProductoConfiguracion(tipoCampo: string): boolean {
    if (this.listaConfiguracionCampos.filter(x => x.dependienciaId === this.form.get('idProducto').value && x.codigo === tipoCampo).length > 0) {
      return this.listaConfiguracionCampos.filter(x => x.dependienciaId === this.form.get('idProducto').value && x.codigo === tipoCampo && x.condicionLogica1).length > 0;
    } else {
      return true;
    }
  }
  CargarListaTipoPlan(idProducto: number) {
    this.listaTipoPlan = this.configuracionService.ListasSistema.filter(x => x.lista === Constantes.LISTAS_PRODUCTOSTIPOPLAN() && x.dependienciaId === idProducto);
    this.EstablecerDatosAdicionalesRequeridos();

    this.form.get('tipoPlan').setValue(null);
    this.form.get('filtroPlan').setValue(null);
    this.listaPlanes = [];

    if (this.listaTipoPlan.length === 1) {
      this.form.get('tipoPlan').setValue(this.listaTipoPlan[0].id);
      this.CargarListaPlan(this.form.get('tipoPlan').value);
    }
  }
  CargarListaTipoBeneficiario(idProducto: number) {
    this.listaTiposBeneficiarios = this.configuracionService.ListasSistema.filter(x => x.lista === Constantes.LISTAS_TIPOSBENEFICIARIO() && x.dependienciaId === idProducto);
  }
  CargarListaTipoAsegurado(idProducto: number) {
    this.listaTipoAsegurado = this.configuracionService.ListasSistema.filter(x => x.lista === Constantes.LISTAS_TIPOASEGURADO() && x.dependienciaId === idProducto);
  }
  CambioTipoPlan() {
    this.CargarListaPlan(this.form.get('tipoPlan').value);
  }
  CambioPlan() {
    this.CargarPrecioPlan(this.form.get('filtroPlan').value, this.form.get('edad').value);
  }
  CargarListaPlan(idTipoPlan: number) {
    this.form.get('filtroPlan').setValue(null);
    this.form.get('plan').setValue(null);

    if (this.utilitariosService.VerificarContieneDatosLista(this.listaTipoPlan)) {
      let calcularPlan: boolean = false;
      if (this.listaTipoPlan.filter(x => x.id === idTipoPlan).length > 0) {
        if (this.utilitariosService.VerificarContieneDatos(this.listaTipoPlan.filter(x => x.id === idTipoPlan)[0].condicionLogica1)) {
          calcularPlan = this.listaTipoPlan.filter(x => x.id === idTipoPlan)[0].condicionLogica1;
        }
      }
  
      if (calcularPlan) {
        var listaPlanesRepetidos = this.configuracionService.ListasSistema.filter(x => x.lista === Constantes.LISTAS_PRODUCTOSPLANES() && x.dependienciaId === idTipoPlan);
        var listaPlanesDistintos:Listas[] = [];
        for (let index = 0; index < listaPlanesRepetidos.length; index++) {
          let item = listaPlanesRepetidos[index];
          if (listaPlanesDistintos.filter(x => x.descripcion === item.descripcion).length === 0) {
            listaPlanesDistintos.push(item);
          }
        }
  
        this.listaPlanes = listaPlanesDistintos;
      } else {
        this.listaPlanes = this.configuracionService.ListasSistema.filter(x => x.lista === Constantes.LISTAS_PRODUCTOSPLANES() && x.dependienciaId === idTipoPlan);
      }
  
      this.EstablecerDatosAdicionalesRequeridos();
  
      if (this.listaPlanes.length === 1) {
        this.form.get('filtroPlan').setValue(this.listaPlanes[0].id);
        this.CargarPrecioPlan(this.form.get('filtroPlan').value, this.form.get('edad').value);
      }
    }
  }
  CargarPrecioPlan(idPlan: number, edad: number) {
    this.form.get('precio').setValue(0);
    if (this.listaTipoPlan.length > 0) {
      let calcularPlan: boolean = false;
      if (this.listaTipoPlan.filter(x => x.id === this.form.get('tipoPlan').value).length > 0) {
        if (this.utilitariosService.VerificarContieneDatos(this.listaTipoPlan.filter(x => x.id === this.form.get('tipoPlan').value)[0].condicionLogica1)) {
          calcularPlan = this.listaTipoPlan.filter(x => x.id === this.form.get('tipoPlan').value)[0].condicionLogica1;
        }
      }

      if (calcularPlan) {
        if (this.listaPlanes.filter(x => x.id === idPlan).length > 0) {
          let descripcionPlan: string = this.listaPlanes.filter(x => x.id === idPlan)[0].descripcion;
          var listaPlanesCompletos = this.configuracionService.ListasSistema.filter(x => x.lista === Constantes.LISTAS_PRODUCTOSPLANES() && x.dependienciaId === this.form.get('tipoPlan').value && x.descripcion === descripcionPlan && x.condicionString1 === 'PRINCIPAL');
          if (listaPlanesCompletos.filter(x => x.condicionEntero2 <= edad && x.condicionEntero3 >= edad).length > 0) {
            let valorNumerico: number = listaPlanesCompletos.filter(x => x.condicionEntero2 <= edad && x.condicionEntero3 >= edad)[0].condicionFloat1;
            let idPlanSeleccion: number = listaPlanesCompletos.filter(x => x.condicionEntero2 <= edad && x.condicionEntero3 >= edad)[0].id;
            this.form.get('precio').setValue(this.utilitariosService.TransformarNumerico(valorNumerico, 0, 'conseparador'));
            this.form.get('plan').setValue(idPlanSeleccion);
          }
        }
      } else {
        if (this.listaPlanes.filter(x => x.id === idPlan).length > 0) {
          let valorNumerico: number = this.listaPlanes.filter(x => x.id === idPlan)[0].condicionFloat1;
          let idPlanSeleccion: number = this.listaPlanes.filter(x => x.id === idPlan)[0].id;
          this.form.get('precio').setValue(this.utilitariosService.TransformarNumerico(valorNumerico, 0, 'conseparador'));
          this.form.get('plan').setValue(idPlanSeleccion);
        }
      }
    }
  }
  CargarListaBeneficiarios(idProducto: number) {
    let listaProductosBeneficiarios: Listas[] = [];
    listaProductosBeneficiarios.push(this.CrearItemListasBeneficiario('nroDocumento', 'Número de identificacion', idProducto, '', 1));
    listaProductosBeneficiarios.push(this.CrearItemListasBeneficiario('nombres', 'Nombres', idProducto, '', 2));
    listaProductosBeneficiarios.push(this.CrearItemListasBeneficiario('apellidos', 'Apellidos', idProducto, '', 3));
    listaProductosBeneficiarios.push(this.CrearItemListasBeneficiario('parentesco', 'Parentesco', idProducto, '', 4));
    listaProductosBeneficiarios.push(this.CrearItemListasBeneficiario('participacion', 'Participación (%)', idProducto, '', 5));

    console.log('CargarListaBeneficiarios', idProducto, this.listaCamposBeneficiarios, this.listaCamposBeneficiarios.filter(x => x.dependienciaId === idProducto));
    if (this.listaCamposBeneficiarios.length > 0) {
      if (this.listaCamposBeneficiarios.filter(x => x.dependienciaId === idProducto).length > 0) {
        this.listaCamposBeneficiariosProducto = this.listaCamposBeneficiarios.filter(x => x.dependienciaId === idProducto);
      } else {
        this.listaCamposBeneficiariosProducto = listaProductosBeneficiarios;
      }
    } else {
        this.listaCamposBeneficiariosProducto = listaProductosBeneficiarios;
    }

    this.listaCamposBeneficiariosProductoMostrar = this.listaCamposBeneficiariosProducto.filter(x => !this.utilitariosService.VerificarContieneDatosTexto(x.dependenciaCodigo)).sort((a, b) => a.condicionEntero1 < b.condicionEntero1 ? -1 : 1);

    this.CargarColumnasEncabezadoBeneficiarios();
    this.recargarListaBeneficiados();
  }
  CargarColumnasEncabezadoBeneficiarios() {
    let listaCamposMostrar: string[] = [];

    for (let index = 0; index < this.listaCamposBeneficiariosProductoMostrar.length; index++) {
      let item = this.listaCamposBeneficiariosProductoMostrar[index];
      if (listaCamposMostrar.filter(x => x === item.codigo).length === 0) {
        listaCamposMostrar.push(item.codigo);
      }
    }

    listaCamposMostrar.push('acciones');

    this.columnasEncabezadoBeneficiados = listaCamposMostrar;
  }
  CrearItemListasBeneficiario(campo: string, descripcion: string, producto: number, origen: string, orden: number): Listas {
    let itemRetorno: Listas = new Listas();
    itemRetorno.codigo = campo;
    itemRetorno.descripcion = descripcion;
    itemRetorno.dependienciaId = producto;
    itemRetorno.dependenciaCodigo = origen;
    itemRetorno.condicionEntero1 = orden;
    return itemRetorno;
  }
  MostrarCampoBeneficiario(tipoCampo: string): boolean {
    if (this.utilitariosService.VerificarContieneDatosLista(this.listaCamposBeneficiariosProductoMostrar)) {
      return this.listaCamposBeneficiariosProductoMostrar.filter(x => x.codigo === tipoCampo && !this.utilitariosService.VerificarContieneDatosTexto(x.dependenciaCodigo)).length > 0;
    }
    return false;
  }
  CargarTituloBeneficiario(tipoCampo: string): string {
    let tituloRetorno: string = '';

    if (this.utilitariosService.VerificarContieneDatosLista(this.listaCamposBeneficiariosProducto)) {
      if (this.listaCamposBeneficiariosProducto.filter(x => x.codigo === tipoCampo && !this.utilitariosService.VerificarContieneDatosTexto(x.dependenciaCodigo)).length > 0) {
        tituloRetorno = this.listaCamposBeneficiariosProducto.filter(x => x.codigo === tipoCampo && !this.utilitariosService.VerificarContieneDatosTexto(x.dependenciaCodigo))[0].descripcion;
      }
    }

    return tituloRetorno;
  }
  MostrarBeneficiarios(): boolean {
    if (this.listaProductosOcultarBeneficiarios) {
      let itemProducto = this.listaProductosOcultarBeneficiarios.filter(x => x.id === this.form.get('idProducto').value);
      if (itemProducto.length > 0) {
        return false;
      }
    }
    return true;
  }
  BeneficiariosRequeridos(): boolean {
    if (this.MostrarBeneficiarios()) {
      if (this.listaProductosBeneficiariosRequeridos) {
        let itemProducto = this.listaProductosBeneficiariosRequeridos.filter(x => x.id === this.form.get('idProducto').value);
        if (itemProducto.length > 0) {
          return true;
        }
      }
    }
    return false;
  }
  TituloOpcionMenu(): string {
    return this.menuService.ObtenerTituloOpcionComponente('RegistrarAfiliadoComponent');
  }
  HabilitarCamposTomador(): boolean {
    if (this.listaProductosTomador) {
      let itemProducto = this.listaProductosTomador.filter(x => x.id === this.form.get('idProducto').value);
      if (itemProducto.length > 0) {
        return true;
      }
    }
    return false;
  }
  CambioTomadorIgualAsegurado(limpiarDatos: boolean = true) {
    if (this.formTomador.get('tomadorIgualAsegurado')?.value) {
      this.formTomador.get('nroDocumentoTomador').setValue(this.form.get('nroDocumento')?.value);
      this.formTomador.get('nombresTomador').setValue(this.form.get('nombres')?.value);
      this.formTomador.get('apellidosTomador').setValue(this.form.get('apellidos')?.value);
      this.formTomador.get('nroMovilTomador').setValue(this.form.get('nroMovil')?.value);
      this.formTomador.get('nroFijoTomador').setValue(this.form.get('nroFijo')?.value);
      this.formTomador.get('emailTomador').setValue(this.form.get('email')?.value);
      this.formTomador.get('domicilioTomador').setValue(this.form.get('domicilio')?.value);
      this.formTomador.get('idDepartamentoTomador').setValue(this.form.get('idDepartamento')?.value);
      this.formTomador.get('idCiudadTomador').setValue(this.form.get('idCiudad')?.value);
      this.formTomador.get('nacimientoTomador').setValue(this.form.get('nacimiento')?.value);
      this.formTomador.get('edadTomador').setValue(this.form.get('edad')?.value);

      this.formTomador.get('nroDocumentoTomadorDeshabilitado').setValue(this.form.get('nroDocumento')?.value);
      this.formTomador.get('nombresTomadorDeshabilitado').setValue(this.form.get('nombres')?.value);
      this.formTomador.get('apellidosTomadorDeshabilitado').setValue(this.form.get('apellidos')?.value);
      this.formTomador.get('nroMovilTomadorDeshabilitado').setValue(this.form.get('nroMovil')?.value);
      this.formTomador.get('nroFijoTomadorDeshabilitado').setValue(this.form.get('nroFijo')?.value);
      this.formTomador.get('emailTomadorDeshabilitado').setValue(this.form.get('email')?.value);
      this.formTomador.get('domicilioTomadorDeshabilitado').setValue(this.form.get('domicilio')?.value);
      this.formTomador.get('nacimientoTomadorDeshabilitado').setValue(this.form.get('nacimiento')?.value);
      this.CargarDescripcionesTomador();
    } else {
      if (this.ejecutarAsignacionTomador) {
        if (limpiarDatos) {
          this.formTomador.get('nroDocumentoTomador').setValue('');
          this.formTomador.get('nombresTomador').setValue('');
          this.formTomador.get('apellidosTomador').setValue('');
          this.formTomador.get('nroMovilTomador').setValue('');
          this.formTomador.get('nroFijoTomador').setValue('');
          this.formTomador.get('emailTomador').setValue('');
          this.formTomador.get('domicilioTomador').setValue('');
          this.formTomador.get('idDepartamentoTomador').setValue('');
          this.formTomador.get('idCiudadTomador').setValue('');
          this.formTomador.get('nacimientoTomador').setValue(new Date());
          this.formTomador.get('edadTomador').setValue(0);
  
          this.formTomador.get('nroDocumentoTomadorDeshabilitado').setValue('');
          this.formTomador.get('nombresTomadorDeshabilitado').setValue('');
          this.formTomador.get('apellidosTomadorDeshabilitado').setValue('');
          this.formTomador.get('nroMovilTomadorDeshabilitado').setValue('');
          this.formTomador.get('nroFijoTomadorDeshabilitado').setValue('');
          this.formTomador.get('emailTomadorDeshabilitado').setValue('');
          this.formTomador.get('domicilioTomadorDeshabilitado').setValue('');
          this.formTomador.get('nacimientoTomadorDeshabilitado').setValue(new Date());
          this.formTomador.get('departamentoTomadorDeshabilitado').setValue('');
          this.formTomador.get('ciudadTomadorDeshabilitado').setValue('');
        }
      }
    }
  }
  EstaTabSeleccionado(tabValidar: string): boolean {
    return this.tabSeleccionadoLabel === tabValidar;
  }
  EstablecerDatosEdicionRegistroProducto() {
    console.log('EstablecerDatosEdicionRegistroProducto');
    if (this.utilitariosService.VerificarContieneDatosTexto(this.menuService.ParametrosAdicionales))  {
      let itemAsignarEdicion: GestionAfiliadoEdicionRegistro = JSON.parse(this.menuService.ParametrosAdicionales);
      console.log('ItemAsignarEdicion', itemAsignarEdicion);
      if (this.utilitariosService.VerificarContieneDatos(itemAsignarEdicion)) {
        this.form.get('idProducto').setValue(itemAsignarEdicion.item.clipro_id);
        this.form.get('idUnico').setValue(itemAsignarEdicion.item.cliproducto_id);
        this.form.get('id').setValue(itemAsignarEdicion.item.cli_id);
        this.form.get('nroDocumento').setValue(itemAsignarEdicion.item.cli_doc);
        this.form.get('nombres').setValue(itemAsignarEdicion.item.cli_nombre);
        this.form.get('apellidos').setValue(itemAsignarEdicion.item.cli_apellido);
        this.form.get('nroMovil').setValue(itemAsignarEdicion.item.cli_cel);
        this.form.get('nroFijo').setValue(itemAsignarEdicion.item.cli_tel);
        this.form.get('email').setValue(itemAsignarEdicion.item.cli_email);
        this.form.get('domicilio').setValue(itemAsignarEdicion.item.cli_domicilio);
        this.form.get('idDepartamento').setValue(itemAsignarEdicion.item.cliprv_codigo);
        this.form.get('idCiudad').setValue(itemAsignarEdicion.item.cliciu_codigo);
        this.form.get('nacimiento').setValue(itemAsignarEdicion.item.cli_nacimiento);
        this.form.get('idProductoPlazo').setValue(itemAsignarEdicion.item.cliproplazo_id);
        this.form.get('edad').setValue(itemAsignarEdicion.item.cli_edad);
        this.form.get('idProductoEdad').setValue(itemAsignarEdicion.item.cliproductoedad_id);
        this.form.get('idProductoEdadDescripcion').setValue(itemAsignarEdicion.item.cliproductoedad_descripcion);
        this.form.get('idEstado').setValue(itemAsignarEdicion.item.cliestado_id);
        this.form.get('nroPoliza').setValue(itemAsignarEdicion.item.cli_nropoliza);
        this.form.get('observaciones').setValue(itemAsignarEdicion.item.cli_observaciones);
        this.form.get('tipoIdentificacion').setValue(itemAsignarEdicion.item.cli_tipoidentificacion);
        this.form.get('expedicionDocumento').setValue(itemAsignarEdicion.item.cli_expediciondocumento);
        this.form.get('departamentoExpedicionDocumento').setValue(itemAsignarEdicion.item.cliciu_expediciondocumento);
        this.form.get('ciudadExpedicionDocumento').setValue(itemAsignarEdicion.item.cliprv_expediciondocumento);
        this.form.get('genero').setValue(itemAsignarEdicion.item.cligenero_id);
        this.form.get('tipoPlan').setValue(itemAsignarEdicion.item.cliproductotipoplan_id);
        this.form.get('plan').setValue(itemAsignarEdicion.item.cliproductoplan_id);
        this.form.get('precio').setValue(itemAsignarEdicion.item.clipro_precio);
        this.form.get('tipoRiesgo').setValue(itemAsignarEdicion.item.cliproductotiporiesgo_id);
        this.form.get('barrio').setValue(itemAsignarEdicion.item.cli_barrio);
        this.form.get('nroPisos').setValue(itemAsignarEdicion.item.cli_nropisos);
        this.form.get('tipoAsegurado').setValue(itemAsignarEdicion.item.cli_tipoasegurado);
        this.form.get('identificacionPagador').setValue(itemAsignarEdicion.item.cli_identificacionpagador);
        this.form.get('periodoPago').setValue(itemAsignarEdicion.item.cli_periodoPago);
        this.form.get('tomadorIgualAsegurado').setValue(itemAsignarEdicion.item.cli_tomadorigualasegurado);
        this.form.get('nroDocumentoTomador').setValue(itemAsignarEdicion.item.cli_doctomador);
        this.form.get('nombresTomador').setValue(itemAsignarEdicion.item.cli_nombretomador);
        this.form.get('apellidosTomador').setValue(itemAsignarEdicion.item.cli_apellidotomador);
        this.form.get('nroMovilTomador').setValue(itemAsignarEdicion.item.cli_celtomador);
        this.form.get('nroFijoTomador').setValue(itemAsignarEdicion.item.cli_teltomador);
        this.form.get('emailTomador').setValue(itemAsignarEdicion.item.cli_emailtomador);
        this.form.get('domicilioTomador').setValue(itemAsignarEdicion.item.cli_domiciliotomador);
        this.form.get('idDepartamentoTomador').setValue(itemAsignarEdicion.item.cliprv_codigotomador);
        this.form.get('idCiudadTomador').setValue(itemAsignarEdicion.item.cliciu_codigotomador);
        this.form.get('nacimientoTomador').setValue(itemAsignarEdicion.item.cli_nacimientotomador);
        this.form.get('edadTomador').setValue(itemAsignarEdicion.item.cli_edadtomador);

        this.formInformacionVehiculo.get('marca').setValue(itemAsignarEdicion.item.marca);
        this.formInformacionVehiculo.get('marcaDescripcion').setValue(itemAsignarEdicion.item.marcaDescripcion);
        this.formInformacionVehiculo.get('referencia').setValue(itemAsignarEdicion.item.referencia);
        this.formInformacionVehiculo.get('referenciaDescripcion').setValue(itemAsignarEdicion.item.referenciaDescripcion);
        this.formInformacionVehiculo.get('modelo').setValue(itemAsignarEdicion.item.modelo);
        this.formInformacionVehiculo.get('placa').setValue(itemAsignarEdicion.item.placa);

        if (this.autenticacionService.RolEditarProductoCliente) {
          this.deshabilitarProducto = false;
        } else {
          this.deshabilitarProducto = true;
        }
        
        this.mostrarCampoEstado = false;
        this.tituloBotonRegistrar = 'Actualizar afiliación';

        this.esEdicionRegistro = true;
        this.filtroPantallaGestionAfiliado = itemAsignarEdicion.filtroGestionAfiliado;

        this.ConsultarGestionAfiliadoDocumentos(itemAsignarEdicion.item.cliproducto_id);
      }
    }
  }
  EstablecerDatosEdicionRegistroTomador() {
    console.log('EstablecerDatosEdicionRegistroTomador');
    if (this.utilitariosService.VerificarContieneDatosTexto(this.menuService.ParametrosAdicionales))  {
      let itemAsignarEdicion: GestionAfiliadoEdicionRegistro = JSON.parse(this.menuService.ParametrosAdicionales);
      console.log('ItemAsignarEdicionTomador');
      if (this.utilitariosService.VerificarContieneDatos(itemAsignarEdicion)) {
        this.formTomador.get('nroDocumentoTomador').setValue(itemAsignarEdicion.item.cli_doctomador);
        this.formTomador.get('nombresTomador').setValue(itemAsignarEdicion.item.cli_nombretomador);
        this.formTomador.get('apellidosTomador').setValue(itemAsignarEdicion.item.cli_apellidotomador);
        this.formTomador.get('nroMovilTomador').setValue(itemAsignarEdicion.item.cli_celtomador);
        this.formTomador.get('nroFijoTomador').setValue(itemAsignarEdicion.item.cli_teltomador);
        this.formTomador.get('emailTomador').setValue(itemAsignarEdicion.item.cli_emailtomador);
        this.formTomador.get('domicilioTomador').setValue(itemAsignarEdicion.item.cli_domiciliotomador);
        this.formTomador.get('idDepartamentoTomador').setValue(itemAsignarEdicion.item.cliprv_codigotomador);
        this.formTomador.get('idCiudadTomador').setValue(itemAsignarEdicion.item.cliciu_codigotomador);
        this.formTomador.get('nacimientoTomador').setValue(itemAsignarEdicion.item.cli_nacimientotomador);
        this.formTomador.get('edadTomador').setValue(itemAsignarEdicion.item.cli_edadtomador);
        this.formTomador.get('nroDocumentoTomadorDeshabilitado').setValue(itemAsignarEdicion.item.cli_doctomador);
        this.formTomador.get('nombresTomadorDeshabilitado').setValue(itemAsignarEdicion.item.cli_nombretomador);
        this.formTomador.get('apellidosTomadorDeshabilitado').setValue(itemAsignarEdicion.item.cli_apellidotomador);
        this.formTomador.get('nroMovilTomadorDeshabilitado').setValue(itemAsignarEdicion.item.cli_celtomador);
        this.formTomador.get('nroFijoTomadorDeshabilitado').setValue(itemAsignarEdicion.item.cli_teltomador);
        this.formTomador.get('emailTomadorDeshabilitado').setValue(itemAsignarEdicion.item.cli_emailtomador);
        this.formTomador.get('domicilioTomadorDeshabilitado').setValue(itemAsignarEdicion.item.cli_domiciliotomador);
        this.formTomador.get('nacimientoTomadorDeshabilitado').setValue(itemAsignarEdicion.item.cli_nacimientotomador);

        this.ejecutarCambiarDatosTomador = false;
        this.formTomador.get('tomadorIgualAsegurado').setValue(itemAsignarEdicion.item.cli_tomadorigualasegurado);
        this.ejecutarAsignacionTomador = false;

        setTimeout(() => {
          this.ejecutarCambiarDatosTomador = true; 
        });
      }
    }
  }
  EstablecerDatosEdicionRegistroBeneficiarios() {
    console.log('EstablecerDatosEdicionRegistroBeneficiarios');
    if (this.utilitariosService.VerificarContieneDatosTexto(this.menuService.ParametrosAdicionales)) {
      let itemAsignarEdicion: GestionAfiliadoEdicionRegistro = JSON.parse(this.menuService.ParametrosAdicionales);
      console.log('ItemAsignarEdicionBeneficiario');
      if (this.utilitariosService.VerificarContieneDatos(itemAsignarEdicion)) {
        this.listaDatosBeneficiados = [];
        if (this.utilitariosService.VerificarContieneDatosLista(itemAsignarEdicion.listaBeneficiarios)) {
          
          for (let index = 0; index < itemAsignarEdicion.listaBeneficiarios.length; index++) {
            let item = itemAsignarEdicion.listaBeneficiarios[index];
            
            let parametroActualizar: GestionAfiliado_Beneficiados = new GestionAfiliado_Beneficiados();
            parametroActualizar.id = item.bene_id;
            parametroActualizar.nroDocumento = item.bene_doc;
            parametroActualizar.nombres = item.bene_nombre;
            parametroActualizar.apellidos = item.bene_apellido;
            parametroActualizar.parentesco = item.beneparentesco_id;
            parametroActualizar.participacion = item.bene_participacion;
            parametroActualizar.tipoBeneficiario = item.benetipo_id;
            parametroActualizar.tipoIdentificacion = item.bene_tipoidentificacion;parametroActualizar.raza = item.bene_raza;
            parametroActualizar.nacimiento = item.bene_nacimiento;
            parametroActualizar.edad = item.bene_edad;
            parametroActualizar.color = item.bene_color;
            parametroActualizar.genero = item.benegenero_id;
            parametroActualizar.parentescoDescripcion = '';
            parametroActualizar.tipoBeneficiarioDescripcion = '';
            parametroActualizar.tipoIdentificacionDescripcion = '';
            parametroActualizar.generoDescripcion = '';
            
            if (this.utilitariosService.VerificarContieneDatosLista(this.listaParentescos)) {
              if (this.listaParentescos.filter(x => x.id === item.beneparentesco_id).length > 0) {
                parametroActualizar.parentescoDescripcion = this.listaParentescos.filter(x => x.id === item.beneparentesco_id)[0].descripcion;
              }
            }

            if (this.utilitariosService.VerificarContieneDatosLista(this.listaTiposBeneficiarios)) {
              if (this.listaTiposBeneficiarios.filter(x => x.id === item.benetipo_id).length > 0) {
                parametroActualizar.tipoBeneficiarioDescripcion = this.listaTiposBeneficiarios.filter(x => x.id === item.benetipo_id)[0].descripcion;
              }
            }

            if (this.utilitariosService.VerificarContieneDatosLista(this.listaTiposIdentificacion)) {
              if (this.listaTiposIdentificacion.filter(x => x.codigo === item.bene_tipoidentificacion).length > 0) {
                parametroActualizar.tipoIdentificacionDescripcion = this.listaTiposIdentificacion.filter(x => x.codigo === item.bene_tipoidentificacion)[0].descripcion;
              }
            }

            if (this.utilitariosService.VerificarContieneDatosLista(this.listaGeneros)) {
              if (this.listaGeneros.filter(x => x.id === item.benegenero_id).length > 0) {
                parametroActualizar.generoDescripcion = this.listaGeneros.filter(x => x.id === item.benegenero_id)[0].descripcion;
              }
            }

            this.listaDatosBeneficiados.push(parametroActualizar);
          }
        }

        this.recargarListaBeneficiados();
      }
    }
  }
  ConsultarGestionAfiliadoDocumentos(idProductoUnico: number) {
    let parametrosConsulta = this.fb.group({
      idAplicacion: [0]
      ,idProductoUnico: [0]
    });
    parametrosConsulta.get('idAplicacion').setValue(this.autenticacionService.AplicacionSeleccionado);
    parametrosConsulta.get('idProductoUnico').setValue(idProductoUnico);
    this.gestionAfiliadoService.ConsultarDocumentos(parametrosConsulta.value)
      .subscribe((resp: GestionAfiliado_DocumentosConsulta[]) =>{
        this.listaDatosDocumentos = [];
        this.listaDatosDocumentosUsuario = [];

        for (let index = 0; index < resp.length; index++) {
          let itemArchivo = resp[index];
          let itemAgregar: GestionAfiliado_Documentos = new GestionAfiliado_Documentos();
          
          itemAgregar.id = itemArchivo.id;
          itemAgregar.nombre = itemArchivo.nombre;
          itemAgregar.orden = (index + 1);

          this.listaDatosDocumentos.push(itemAgregar);
          this.listaDatosDocumentosUsuario.push(itemAgregar);
        }
      },
      (error: Error) => {
        this.utilitariosService.ObtenerMensajeErrorRespuesta(error);
        this.mostrarCargando = false;
        this.cd.detectChanges();
      },
      () => this.cd.detectChanges());
    }
  DeshabilitarTomadorIgualAsegurado(): boolean {
    if (this.utilitariosService.VerificarContieneDatos(this.formTomador)) {
      return this.formTomador.get('tomadorIgualAsegurado')?.value;
    }
    
    return false;
  }
  CargarDescripcionesTomador() {
    this.CargarListaCiudadesTomador(this.formTomador.get('idDepartamentoTomador')?.value);
    if (this.utilitariosService.VerificarContieneDatosLista(this.listaDepartamentos)) {
      if (this.listaDepartamentos.filter(x => x.codigo === this.formTomador.get('idDepartamentoTomador')?.value).length > 0) {
        this.formTomador.get('departamentoTomadorDeshabilitado').setValue(this.listaDepartamentos.filter(x => x.codigo === this.formTomador.get('idDepartamentoTomador')?.value)[0].descripcion);
      }
    }

    if (this.utilitariosService.VerificarContieneDatosLista(this.listaCiudadesTomador)) {
      if (this.listaCiudadesTomador.filter(x => x.codigo === this.formTomador.get('idCiudadTomador')?.value).length > 0) {
        this.formTomador.get('ciudadTomadorDeshabilitado').setValue(this.listaCiudadesTomador.filter(x => x.codigo === this.formTomador.get('idCiudadTomador')?.value)[0].descripcion);
      }
    }
  }
  MostrarTabVehiculo(): boolean {
    if (this.MostrarCampoProducto('MARCA') 
      && this.MostrarCampoProducto('REFERENCIA')
      && this.MostrarCampoProducto('MODELO')
      && this.MostrarCampoProducto('PLACA')) {
      return true;
    }
    return false;
  }
  MostrarTabRegistroFotografico(): boolean {
    if (this.MostrarCampoProducto('DOCUMENTOSADJUNTOS')) {
      return true;
    }
    return false;
  }
  CargarListaMarcas() {
    let parametrosConsulta = this.fb.group({
      idAplicacion: [0]
    });
    parametrosConsulta.get('idAplicacion').setValue(this.autenticacionService.AplicacionSeleccionado);
    this.gestionAfiliadoService.ConsultarMarcas(parametrosConsulta.value)
                .subscribe((resp: Marcas[]) =>{
                  this.listaMarcas = resp;
                  this.FiltroMarca();
                },
                (error: Error) => {
                  this.utilitariosService.ObtenerMensajeErrorRespuesta(error);
                  this.mostrarCargando = false;
                  this.cd.detectChanges();
                },
                () => this.cd.detectChanges());
  }
  CargarListaReferencias(marca: number) {
    this.formInformacionVehiculo.get('referencia').setValue(0);
    this.formInformacionVehiculo.get('referenciaDescripcion').setValue('');

    let parametrosConsulta = this.fb.group({
      idAplicacion: [0]
      ,marca: [0]
    });
    parametrosConsulta.get('idAplicacion').setValue(this.autenticacionService.AplicacionSeleccionado);
    parametrosConsulta.get('marca').setValue(marca);
    this.gestionAfiliadoService.ConsultarMarcasReferencias(parametrosConsulta.value)
                .subscribe((resp: MarcasReferencias[]) =>{
                  this.listaMarcasRefecencias = resp;
                  this.FiltroMarcasReferencias();

                  if (this.listaMarcasRefecencias.length === 1) {
                    this.formInformacionVehiculo.get('referencia').setValue(this.listaMarcasRefecencias[0].id);
                    this.formInformacionVehiculo.get('referenciaDescripcion').setValue(this.listaMarcasRefecencias[0].descripcion);
                  }
                },
                (error: Error) => {
                  this.utilitariosService.ObtenerMensajeErrorRespuesta(error);
                  this.mostrarCargando = false;
                  this.cd.detectChanges();
                },
                () => this.cd.detectChanges());
  }
  SeleccionoArchivo(parametros: any) {
    console.log('SeleccionoArchivo', parametros);
    if (parametros.subioArchivo) {
      this.mostrarCargando = true;
      
    }
  }
  ArchivoSeleccionar(_Archivos: File[]) {
    console.log('ArchivoSeleccionar', _Archivos);
    for (let index = 0; index < _Archivos.length; index++) {
      const archivo = _Archivos[index];
      if (archivo.type.startsWith('image/')) {
        
        if (this.listaDatosDocumentosUsuario.filter(x => x.nombre === archivo.name).length > 0) {
          this.listaDatosDocumentosUsuario.filter(x => x.nombre === archivo.name)[0].archivo = archivo;
        } else {
          let itemAgregar: GestionAfiliado_Documentos = new GestionAfiliado_Documentos();
          itemAgregar.id = (this.listaDatosDocumentosUsuario.length + 1) * -1;
          itemAgregar.nombre = archivo.name;
          itemAgregar.archivo = archivo;
          itemAgregar.orden = this.listaDatosDocumentosUsuario.length + 1;
  
          this.listaDatosDocumentosUsuario.push(itemAgregar);
        }
      }
    }
  }
  AbrirModalSeleccionarArchivos() {
    console.log('AbrirModalSeleccionarArchivos');
    this._uploadFile.nativeElement.value = '';
    this._uploadFile.nativeElement.click();
  }
  RemoverArchivo(index: number) {
    console.log('RemoverArchivo', index);
    this.listaDatosDocumentosUsuario.splice(index, 1)
  }
  FiltroMarca(): void {
    const filterValue = this._inputMarca.nativeElement.value.toLowerCase();
    this.listaMarcasFiltrada = this.listaMarcas.filter(o => o.descripcion.toLowerCase().includes(filterValue));
  }
  VerificarMarcaSeleccionada(): void {
    const filterValue = this._inputMarca.nativeElement.value;
    if (this.listaMarcas.filter(o => o.descripcion === filterValue).length === 0) {
      this.LimpiarMarca();
    }
  }
  FiltroMarcasReferencias(): void {
    const filterValue = this._inputMarcaReferencia.nativeElement.value.toLowerCase();
    this.listaMarcasRefecenciasFiltrada = this.listaMarcasRefecencias.filter(o => o.descripcion.toLowerCase().includes(filterValue));
  }
  VerificarMarcaReferenciasSeleccionada(): void {
    const filterValue = this._inputMarcaReferencia.nativeElement.value;
    if (this.listaMarcasRefecencias.filter(o => o.descripcion === filterValue).length === 0) {
      this.LimpiarMarcaReferencia();
    }
  }
  QuitarMarca() {
    this.mostrarBuscadorMarca = true;
    this.QuitarMarcaReferencia();
  }
  QuitarMarcaReferencia() {
    this.mostrarBuscadorMarcaReferencia = true;
  }
  LimpiarMarca() {
    this.formInformacionVehiculo.get('marca').setValue(0);
    this.formInformacionVehiculo.get('referenciaDescripcion').setValue('');
  }
  LimpiarMarcaReferencia() {
    this.formInformacionVehiculo.get('referencia').setValue(0);
    this.formInformacionVehiculo.get('referenciaDescripcion').setValue('');
  }
  AnnoMinimoModelo(): number {
    if (this.utilitariosService.VerificarContieneDatosLista(this.listaProductosAnnosModelo)) {
      if (this.listaProductosAnnosModelo.filter(x => x.id === this.form.get('idProducto').value).length > 0) {
        let cantidadAnnosMaximo: number = this.listaProductosAnnosModelo.filter(x => x.id === this.form.get('idProducto').value)[0].condicionEntero1;
        
        return new Date().getFullYear() - cantidadAnnosMaximo;
      }
    }
    return 0;
  }
}
